import { setAttr } from '@/helpers/contentful.helper';
import { T_KeyValue } from '@/types/app.type';

export const content: T_KeyValue = {
    "common": {
        id: setAttr({
            displayName: 'Id',
            group: "content",
        })
    },
    // "contentfulSection": {
    //     id: setAttr({
    //         displayName: 'id',
    //         group: "content",
    //     })
    // },
    "box": {
        children: setAttr({
            displayName: 'Children',
            type: 'Object',
            group: "content",
        })
    },
    "block": {
        children: setAttr({
            displayName: 'Children',
            type: 'Object',
            group: "content",
        })
    },
    "card": {
        children: setAttr({
            displayName: 'Children',
            type: 'Object',
            group: "content",
        })
    },
    "button": {
        value: setAttr({
            displayName: 'Text',
            defaultValue: 'Click me!',
            group: "content",
        }),
        type: setAttr({
            displayName: 'Type',
            defaultValue: 'button',
            validations: {
                in: [{ value: 'button' }, { value: 'submit' }, { value: 'reset' }]
            },
            group: "content",
        }),
        className: setAttr({
            displayName: 'Css Class',
            description: 'The css class',
            group: 'content'
        }),
        url: setAttr({
            displayName: 'URL',
            defaultValue: '/',
        })
    },
    topNav: {
        // isDraftEnabled: setAttr({
        //     displayName: 'Enable edit mode',
        //     defaultValue: false,
        //     type: "Boolean",
        //     group: "content",
        // }),
        internalName: setAttr({
            displayName: 'Internal Name',
            defaultValue: "",
            group: "content",
        }),
        backUrl: setAttr({
            displayName: 'Back Url',
            defaultValue: "",
            group: "content",
        }),
        logo: setAttr({
            displayName: 'Logo',
            defaultValue: "",
            type: "Media",
            group: "content",
        }),
        logoAlignment: setAttr({
            displayName: 'Logo Alignment',
            defaultValue: "Left",
            validations: {
                in: [
                    { value: 'Left', displayName: 'Left' },
                    { value: 'Center', displayName: 'Center' },
                    { value: 'Right', displayName: 'Right' },
                ]
            }
        }),
        enableBurgerMenu: setAttr({
            displayName: 'Enable Burger Menu',
            defaultValue: false,
            type: "Boolean",
        }),
        burgerIconPosition: setAttr({
            displayName: 'Burger Icon Position',
            defaultValue: "Left",
            validations: {
                in: [
                    { value: 'Left', displayName: 'Left' },
                    { value: 'Right', displayName: 'Right' },
                ]
            }
        }),
        menuAlignment: setAttr({
            displayName: 'Menu Alignment On Large Screen',
            defaultValue: "Left",
            validations: {
                in: [
                    { value: 'Left', displayName: 'Left' },
                    { value: 'Center', displayName: 'Center' },
                    { value: 'Right', displayName: 'Right' },
                ]
            }
        }),
        menuAlignmentOnMobile: setAttr({
            displayName: 'Menu Alignment On Small Screen',
            defaultValue: "Left",
            validations: {
                in: [
                    { value: 'Left', displayName: 'Left' },
                    { value: 'Center', displayName: 'Center' },
                    { value: 'Right', displayName: 'Right' },
                ]
            }
        }),
        // menuPosition: setAttr({
        //     displayName: 'Menu Position',
        //     defaultValue: "",
        //     group: "content",
        // }),
        pages: setAttr({
            displayName: 'Menus/Pages',
            // defaultValue: {},
            type: "Array",
            group: "content",
        }),
        ctaPositionOnTab: setAttr({
            displayName: 'CTA Position On Tab',
            defaultValue: "",
            validations: {
                in: [
                    { value: 'Top Navigation Bar', displayName: 'Top Navigation Bar' },
                    { value: 'Expanded Menu', displayName: 'Expanded Menu' },
                    { value: 'Bottom of the Screen', displayName: 'Bottom of the Screen' },
                ]
            }
        }),
        ctaPositionOnMobile: setAttr({
            displayName: 'CTA Position On Mobile',
            defaultValue: "",
            validations: {
                in: [
                    { value: 'Top Navigation Bar', displayName: 'Top Navigation Bar' },
                    { value: 'Expanded Menu', displayName: 'Expanded Menu' },
                    { value: 'Bottom of the Screen', displayName: 'Bottom of the Screen' },
                ]
            }
        }),
        ctaWidth: setAttr({
            displayName: 'CTA Width',
            defaultValue: "w-full",
            validations: {
                in: [
                    { value: 'w-auto', displayName: 'Auto' },
                    { value: 'w-fit', displayName: 'Fit' },
                    { value: 'w-min', displayName: 'Min' },
                    { value: 'w-max', displayName: 'Max' },
                    { value: 'w-full', displayName: 'Full' },
                ]
            }
        }),
        ctaAlign: setAttr({
            displayName: 'CTA Alignment',
            defaultValue: "center",
            validations: {
                in: [
                    { value: 'left', displayName: 'Left' },
                    { value: 'center', displayName: 'Center' },
                    { value: 'right', displayName: 'Right' },
                ]
            }
        }),
        ctaBottomMargin: setAttr({
            displayName: 'CTA Bottom Margin',
            defaultValue: 15,
            type: "Number",
            validations: {
                in: [
                    { value: 0, displayName: '0px' },
                    { value: 1, displayName: '1px' },
                    { value: 2, displayName: '2px' },
                    { value: 3, displayName: '3px' },
                    { value: 4, displayName: '4px' },
                    { value: 5, displayName: '5px' },
                    { value: 15, displayName: '15px' },
                    { value: 20, displayName: '20px' },
                    { value: 25, displayName: '25px' },
                    { value: 30, displayName: '30px' },
                    { value: 35, displayName: '35px' },
                    { value: 40, displayName: '40px' },
                    { value: 45, displayName: '45px' },
                    { value: 50, displayName: '50px' }
                ]
            }
        }),
        ctaLeftMargin: setAttr({
            displayName: 'CTA Left Margin',
            defaultValue: 55,
            type: "Number",
            validations: {
                in: [
                    // { value: 10000, displayName: 'Auto' },
                    { value: 0, displayName: '0px' },
                    { value: 1, displayName: '1px' },
                    { value: 2, displayName: '2px' },
                    { value: 3, displayName: '3px' },
                    { value: 4, displayName: '4px' },
                    { value: 5, displayName: '5px' },
                    { value: 15, displayName: '15px' },
                    { value: 20, displayName: '20px' },
                    { value: 25, displayName: '25px' },
                    { value: 30, displayName: '30px' },
                    { value: 35, displayName: '35px' },
                    { value: 40, displayName: '40px' },
                    { value: 45, displayName: '45px' },
                    { value: 50, displayName: '50px' },
                    { value: 55, displayName: '55px' },
                    { value: 60, displayName: '60px' },
                    { value: 65, displayName: '65px' },
                    { value: 70, displayName: '70px' },
                    { value: 75, displayName: '75px' },
                    { value: 80, displayName: '80px' },
                    { value: 85, displayName: '85px' },
                    { value: 90, displayName: '90px' },
                    { value: 95, displayName: '95px' },
                    { value: 100, displayName: '100px' }
                ]
            }
        }),
        ctaRightMargin: setAttr({
            displayName: 'CTA Right Margin',
            defaultValue: 55,
            type: "Number",
            validations: {
                in: [
                    // { value: 10000, displayName: 'Auto' },
                    { value: 0, displayName: '0px' },
                    { value: 1, displayName: '1px' },
                    { value: 2, displayName: '2px' },
                    { value: 3, displayName: '3px' },
                    { value: 4, displayName: '4px' },
                    { value: 5, displayName: '5px' },
                    { value: 15, displayName: '15px' },
                    { value: 20, displayName: '20px' },
                    { value: 25, displayName: '25px' },
                    { value: 30, displayName: '30px' },
                    { value: 35, displayName: '35px' },
                    { value: 40, displayName: '40px' },
                    { value: 45, displayName: '45px' },
                    { value: 50, displayName: '50px' },
                    { value: 55, displayName: '55px' },
                    { value: 60, displayName: '60px' },
                    { value: 65, displayName: '65px' },
                    { value: 70, displayName: '70px' },
                    { value: 75, displayName: '75px' },
                    { value: 80, displayName: '80px' },
                    { value: 85, displayName: '85px' },
                    { value: 90, displayName: '90px' },
                    { value: 95, displayName: '95px' },
                    { value: 100, displayName: '100px' }
                ]
            }
        }),
        isAMegaMenu: setAttr({
            displayName: 'Mega Menu?',
            defaultValue: false,
            type: "Boolean",
        }),
        varient: setAttr({
            displayName: 'Varient',
            defaultValue: "",
            validations: {
                in: [
                    { value: 'Fixed on top', displayName: 'Fixed on top' },
                    { value: 'Sticky on top', displayName: 'Sticky on top' },
                    { value: 'Hide on scroll', displayName: 'Hide on scroll' },
                    { value: 'Static', displayName: 'Static' }
                ]
            }
        }),
        // tabVarient: setAttr({
        //     displayName: 'Tab Varient',
        //     defaultValue: "",
        //     validations: {
        //         in: [
        //             { value: 'Fixed on top', displayName: 'Fixed on top' },
        //             { value: 'Sticky on top', displayName: 'Sticky on top' },
        //             { value: 'Hide on scroll', displayName: 'Hide on scroll' },
        //         ]
        //     }
        // }),
        buttonsBackgroundColor: setAttr({
            displayName: 'Buttons Background Color',
            validations: {
                in: [
                    { displayName: "Yellow", value: "#FFDB00" },
                    { displayName: "White", value: "#FFFFFF" },
                    { displayName: "Dark", value: "#1A1A1A" },
                    { displayName: "Light-Brown", value: "#F7F4EF" },
                    { displayName: "Dark-Brown", value: "#EAE3DA" },
                    { displayName: "Blue", value: "#B0D7EC" },
                    { displayName: "Dark-Blue", value: "#0f102a" },
                    { displayName: "Coral-Blue", value: "#B6D9ED" },
                    { displayName: "Grey", value: "#E0E0E0" },
                    { displayName: "Sea-Mist", value: "#C0DDCC" },
                ]
            },
            defaultValue: '#FFDB00',
        }),
        buttonsBorderColor: setAttr({
            displayName: 'Buttons Border Color',
            validations: {
                in: [
                    { displayName: "Yellow", value: "#FFDB00" },
                    { displayName: "White", value: "#FFFFFF" },
                    { displayName: "Dark", value: "#1A1A1A" },
                    { displayName: "Light-Brown", value: "#F7F4EF" },
                    { displayName: "Dark-Brown", value: "#EAE3DA" },
                    { displayName: "Blue", value: "#B0D7EC" },
                    { displayName: "Dark-Blue", value: "#0f102a" },
                    { displayName: "Coral-Blue", value: "#B6D9ED" },
                    { displayName: "Grey", value: "#E0E0E0" },
                    { displayName: "Sea-Mist", value: "#C0DDCC" },
                ]
            },
            defaultValue: '#FFDB00',
        }),
        megaMenuMaxHeight: setAttr({
            displayName: 'Mega Menu max height',
            validations: {
                in: [
                    { displayName: "None", value: "none" },
                    { displayName: "50vh", value: "50vh" },
                    { displayName: "75vh", value: "75vh" },
                    { displayName: "100vh", value: "100vh" },
                ]
            },
            defaultValue: 'none',
        }),
        customizeTopMenu: setAttr({
            displayName: "Customize top menu?",
            description: "Customize top menu by dragging and dropping elements from left panel.",
            type: "Boolean",
            defaultValue: false
        }),
        closeMenuEventName: setAttr({
            displayName: 'Close Menu Event name',
            type: 'Text',
            description: 'DOM event name that closes the top nav',
            group: 'style'
        }),
        expandEvent: setAttr({
            displayName: 'Expand event',
            type: 'Text',
            description: 'DOM event sent when menu is expanded',
            group: 'style'
        }),
        collapseEvent: setAttr({
            displayName: 'Collapse event',
            type: 'Text',
            description: 'DOM event sent when menu is collapsed',
            group: 'style'
        }),
        // hideLeftSegment: setAttr({
        //     displayName: "Hide left segment",
        //     type: "Boolean",
        //     defaultValue: false
        // }),
        // hideCenterSegment: setAttr({
        //     displayName: "Hide center segment",
        //     type: "Boolean",
        //     defaultValue: false
        // }),
        // hideRightSegment: setAttr({
        //     displayName: "Hide right segment",
        //     type: "Boolean",
        //     defaultValue: false
        // }),
        // sameAsTopMenuCTAs: setAttr({
        //     displayName: "Same as top nav CTAs",
        //     type: "Boolean",
        //     defaultValue: false
        // })
    },
    form: {
        title: setAttr({
            displayName: 'Form title',
            defaultValue: "Add title here...",
            group: "content",
        }),
        api: setAttr({
            displayName: 'API name',
            defaultValue: "select",
            group: "style",
            validations: {
                in: [
                    { value: 'select', displayName: 'Select an endpoint' },
                    { value: 'contactUs', displayName: 'Contact' },
                    { value: 'newsletter', displayName: 'Newsletter' },
                    // { value: 'newsletter-booking', displayName: 'Newsletter-Booking' },
                    { value: 'customApi', displayName: 'Custom API' },
                ]
            }
        }),
        customApi: setAttr({
            displayName: 'Custom API name',
            description: 'Custom API name',
            group: 'style'
        }),

        responseEmailTemplate: setAttr({
            displayName: 'Response Email Template',
            description: 'The Template used for the email to the user',
            type: 'RichText',
            group: 'content'
        }),
        forwardingEmailTemplate: setAttr({
            displayName: 'Forward Email Template',
            description: 'The Template used for the email forwarded to Ingka',
            type: 'RichText',
            group: 'content'
        }),
        forwardingEmailSubject: setAttr({
            displayName: 'Forward Email Subject',
            description: 'The Subject used for the forward email',
            group: 'content'
        }),
        responseEmailSubject: setAttr({
            displayName: 'Response Email Subject',
            description: 'The Subject used for the response email to the user',
            group: 'content'
        }),
        topImage: setAttr({
            displayName: 'Top Image',
            type: 'Media',
            group: 'content'
        }),
        bottomImage: setAttr({
            displayName: 'Bottom Image',
            type: 'Media',
            group: 'content'
        }),
        attachment: setAttr({
            displayName: 'Email Attachments',
            type: 'Media',
            group: 'content'
        }),
        responseMessages: setAttr({
            displayName: 'Response messages',
            //The JSON accepted by the 'response messages' variable has to have the following syntax:
            //The object will have status codes that corresponds to the API status codes and the messages that need to be displayed accordingly.
            //The messages can be given in different locales as shown below.
            defaultValue: {
                "200": {
                    "sv": "",
                    "en": ""
                },
                "409": { "sv": "Åh åh! Det gick inte att prenumerera.", "en": "Uh oh! Could not subscribe." },
                "500": { "sv": "Åh åh! Det gick inte att prenumerera. Försök igen senare.", "en": "Uh oh! Could not subscribe. Try again later." },
                "error": { "sv": "Åh åh! Det gick inte att prenumerera. Försök igen senare.", "en": "Uh oh! Could not subscribe. Try again later." },
                "confirmEmail": { "sv": "E-postmeddelanden matchar inte.", "en": "Emails do not match." },
                "multipleSubmit": { "sv": "Kan inte skicka igen!", "en": "Cannot submit again!" }
            },
            description: 'The response messages of the form',
            group: 'content',
            type: 'Object',
        }),
        // responseMapConfig: setAttr({
        //     displayName: 'Response map config',
        //     description: 'CMS-managed response message and data mapping config for third-party APIs',
        //     group: 'content',
        //     type: 'Object',
        // }),
        scroll: setAttr({
            displayName: 'Scrolling',
            description: 'Allow form to scroll',
            type: 'Boolean',
            defaultValue: false,
            group: 'style'
        }),
        scrollOnSubmit: setAttr({
            displayName: 'Scroll on submit',
            description: 'Allow form to scroll on submit',
            type: 'Boolean',
            defaultValue: true,
            group: 'style'
        }),
        customSuccessContent: setAttr({
            displayName: 'Custom Success Content',
            description: 'Show custom success screen',
            type: 'Boolean',
            defaultValue: false,
            group: 'style'
        }),
    },
    // Comman parameters for inputFields
    commanInputParams: {
        labelSize: setAttr({
            displayName: 'Label size',
            description: 'The size of label font',
            defaultValue: 'l',
            validations: {
                in: [
                    { value: 'sm', displayName: 'Small' },
                    { value: 'base', displayName: 'Normal/Base' },
                    { value: 'md', displayName: 'Medium' },
                    { value: 'lg', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' },
                ]
            },
        }),
        labelColor: setAttr({
            displayName: 'Label color',
            group: 'style',
            validations: {
                in: [
                    { displayName: "Yellow", value: "#FFDB00" },
                    { displayName: "White", value: "#FFFFFF" },
                    { displayName: "Dark", value: "#1A1A1A" },
                    { displayName: "Light-Brown", value: "#F7F4EF" },
                    { displayName: "Dark-Brown", value: "#EAE3DA" },
                    { displayName: "Blue", value: "#B0D7EC" },
                    { displayName: "Dark-Blue", value: "#0f102a" },
                    { displayName: "Coral-Blue", value: "#B6D9ED" },
                    { displayName: "Grey", value: "#E0E0E0" },
                    { displayName: "Sea-Mist", value: "#C0DDCC" },
                ]
            },
            defaultValue: '#1A1A1A',
        }),
        required: setAttr({
            displayName: 'Required',
            type: 'Boolean',
            group: 'style',
            defaultValue: false
        }),
        disabled: setAttr({
            displayName: 'Disabled',
            type: 'Boolean',
            group: 'style'
        }),
        // validations: setAttr({
        //     displayName: 'Validations',
        //     type: 'Object',
        //     group: 'style'
        // }),
        placeholder: setAttr({
            displayName: 'Placeholder Value',
            group: 'content'
        }),
        // pattern: setAttr({
        //     displayName: 'Pattern/Regex',
        //     defaultValue: "^[A-Za-z0-9 ]*$",
        //     group: 'style'
        // })

        helperText: setAttr({
            displayName: 'Helper Text',
            description: 'Text to help user for input value.',
            group: 'content',
            defaultValue: ''
        }),
    },

    // Hidden input box params
    hiddenField: {
        type: setAttr({
            displayName: 'Hidden Field Type',
            group: 'style',
            defaultValue: "hidden",
            validations: {
                in: [
                    { value: 'hidden', displayName: 'Hidden' }
                ]
            },
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Field Name Value for backend processing',
            group: 'style'
        }),
        inputSource: setAttr({
            displayName: 'Input Store',
            description: 'Input Field Name Value for backend processing',
            defaultValue: "manual",
            validations: {
                in: [
                    { value: 'manual', displayName: 'Manual' },
                    { value: 'query', displayName: 'Query' },
                    { value: 'cookie', displayName: 'Cookie' }
                ]
            },
            group: 'style'
        }),
        inputKey: setAttr({
            displayName: 'Input Key',
            description: 'Input key value for cookie source',
            group: 'style'
        }),
        defaultValue: setAttr({
            displayName: 'Field value',
            description: 'Input Field Value for backend processing',
            group: 'content'
        })
    },

    // Text input box params
    inputField: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Input Field Type',
            group: 'style',
            defaultValue: "text",
            validations: {
                in: [
                    { value: 'text', displayName: 'Textbox' },
                    { value: 'textarea', displayName: 'Multiline text' },
                    { value: 'password', displayName: 'Password' },
                    // { value: 'email', displayName: 'Email' },
                    // { value: 'tel', displayName: 'Phone' },
                    // { value: 'number', displayName: 'Number' },
                    // { value: 'select', displayName: 'Select' },
                    // { value: 'checkbox', displayName: 'Checkbox' },
                    // { value: 'radio', displayName: 'Radio button' },
                ]
            },
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Field Name Value for backend processing',
            group: 'style',
            defaultValue: "fullName",
            validations: {
                in: [
                    { value: 'firstName', displayName: 'First name' },
                    { value: 'lastName', displayName: 'Last name' },
                    { value: 'fullName', displayName: 'Full name' },
                    { value: 'company', displayName: 'Company' },
                    // { value: 'email', displayName: 'Email' },
                    // { value: 'altEmail', displayName: 'Alt email' },
                    // { value: 'confirmEmail', displayName: 'Confirm email' },
                    // { value: 'phonePrefix', displayName: 'Phone prefix' },
                    // { value: 'contactNumber', displayName: 'Contact number' },
                    // { value: 'altContactNumber', displayName: 'Alt contact number' },
                    // { value: 'confirmContactNumber', displayName: 'Confirm contact number' },
                    { value: 'subject', displayName: 'Subject' },
                    { value: 'message', displayName: 'Message' },
                    // { value: 'termsConsent', displayName: 'Terms consent' },
                    // { value: 'privacyConsent', displayName: 'Privacy consent' },
                    // { value: 'marketingConsent', displayName: 'Marketing consent' },
                    { value: 'password', displayName: 'Password' },
                    { value: 'custom', displayName: 'Custom' }
                ]
            },
        }),
        customName: setAttr({
            displayName: 'Custom Field Name',
            description: "Input Field Name Value for backend processing",
            group: 'style'
        }),
        pattern: setAttr({
            displayName: 'Pattern/Regex',
            defaultValue: "^[A-Za-z0-9 ]*$",
            group: 'style'
        }),
        maxLength: setAttr({
            displayName: 'Max Length',
            group: 'style',
            defaultValue: '255'
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
        formatErrorMessage: setAttr({
            displayName: 'Pattern/Regex Match Error Message',
            description: 'Error message to be displayed when validaitons are not fullfiled',
            group: 'content',
            defaultValue: 'Not a valid data.'
        }),
        // charLengthErrorMessage: setAttr({
        //     displayName: 'Char Length Error Message',
        //     description: 'Char max length reached.',
        //     group: 'content',
        //     defaultValue: 'Max char length is 255.'
        // })
    },

    // Number input box params
    numberInputField: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Input Field Type',
            group: 'style',
            defaultValue: "number",
            validations: {
                in: [
                    { value: 'number', displayName: 'Number' }
                ]
            },
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Field Name Value for backend processing',
            group: 'style',
            defaultValue: "number",
            validations: {
                in: [
                    { value: 'number', displayName: 'Number' },
                    { value: 'custom', displayName: 'Custom' }
                ]
            },
        }),
        pattern: setAttr({
            displayName: 'Pattern/Regex',
            defaultValue: "^[0-9]*$",
            group: 'style'
        }),
        min: setAttr({
            displayName: 'Min value',
            group: 'style',
            defaultValue: '0'
        }),
        max: setAttr({
            displayName: 'Max value',
            group: 'style',
            defaultValue: '100'
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
        formatErrorMessage: setAttr({
            displayName: 'Pattern/Regex Match Error Message',
            description: 'Error message to be displayed when validaitons are not fullfiled',
            group: 'content',
            defaultValue: 'Not a valid number.'
        }),
    },

    // Email input field params
    emailInputField: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Input Field Type',
            group: 'style',
            defaultValue: "email",
            validations: {
                in: [
                    { value: 'email', displayName: 'Email' }
                ]
            },
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Field Name Value for backend processing',
            group: 'style',
            defaultValue: "email",
            validations: {
                in: [
                    { value: 'email', displayName: 'Email' },
                    { value: 'altEmail', displayName: 'Alt email' },
                    { value: 'confirmEmail', displayName: 'Confirm email' }
                ]
            },
        }),
        pattern: setAttr({
            displayName: 'Pattern/Regex',
            defaultValue: "^[\\w\\-\\.]+@([\\w\\-]+\\.)+[\\w\\-]{2,4}$",
            // defaultValue: "^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$",
            group: 'style'
        }),
        maxLength: setAttr({
            displayName: 'Max Length',
            group: 'style',
            defaultValue: '255'
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
        formatErrorMessage: setAttr({
            displayName: 'Pattern/Regex Match Error Message',
            description: 'Error message to be displayed when validaitons are not fullfiled',
            group: 'content',
            defaultValue: 'Not a valid email address.'
        }),
        confirmationErrorMessage: setAttr({
            displayName: 'Confirm Field Error Message',
            description: 'Error message to be displayed when two fields are not same',
            group: 'content',
            defaultValue: 'Both emails are not same.'
        }),
        fieldToConfirm: setAttr({
            displayName: 'Field to confirm',
            description: 'Select field A for comparison',
            group: 'style',
            defaultValue: "email",
            validations: {
                in: [
                    { value: 'email', displayName: 'Email' },
                    { value: 'confirmEmail', displayName: 'Confirm email' },
                    { value: 'contactNumber', displayName: 'Contact number' },
                    { value: 'confirmContactNumber', displayName: 'Confirm contact number' }
                ]
            },
        }),
        confirmationField: setAttr({
            displayName: 'Confirmation field',
            description: 'Select field B for comparison',
            group: 'style',
            defaultValue: "confirmEmail",
            validations: {
                in: [
                    { value: 'email', displayName: 'Email' },
                    { value: 'confirmEmail', displayName: 'Confirm email' },
                    { value: 'contactNumber', displayName: 'Contact number' },
                    { value: 'confirmContactNumber', displayName: 'Confirm contact number' }
                ]
            },
        }),
    },

    // Phone input field params
    phoneInputField: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Input Field Type',
            group: 'style',
            defaultValue: "tel",
            validations: {
                in: [
                    { value: 'tel', displayName: 'Phone' }
                ]
            },
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Field Name Value for backend processing',
            group: 'style',
            defaultValue: "contactNumber",
            validations: {
                in: [
                    { value: 'phonePrefix', displayName: 'Phone prefix' },
                    { value: 'contactNumber', displayName: 'Contact number' },
                    { value: 'altContactNumber', displayName: 'Alt contact number' },
                    { value: 'confirmContactNumber', displayName: 'Confirm contact number' }
                ]
            },
        }),
        pattern: setAttr({
            displayName: 'Pattern/Regex',
            defaultValue: "^[+]*[\(]{0,1}[0-9]{1,4}[\)]{0,1}[\-\s\.0-9]*$",
            group: 'style'
        }),
        maxLength: setAttr({
            displayName: 'Max Length',
            group: 'style',
            defaultValue: '255'
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
        formatErrorMessage: setAttr({
            displayName: 'Pattern/Regex Match Error Message',
            description: 'Error message to be displayed when validaitons are not fullfiled',
            group: 'content',
            defaultValue: 'Not a valid phone number.'
        }),
        confirmationErrorMessage: setAttr({
            displayName: 'Field Error Message',
            description: 'Error message to be displayed when two fields are not same',
            group: 'content',
            defaultValue: 'Both phone numbers are not same.'
        }),
        fieldToConfirm: setAttr({
            displayName: 'Field to confirm',
            description: 'Select field A for comparison',
            group: 'style',
            defaultValue: "contactNumber",
            validations: {
                in: [
                    { value: 'email', displayName: 'Email' },
                    { value: 'confirmEmail', displayName: 'Confirm email' },
                    { value: 'contactNumber', displayName: 'Contact number' },
                    { value: 'confirmContactNumber', displayName: 'Confirm contact number' }
                ]
            },
        }),
        confirmationField: setAttr({
            displayName: 'Confirmation field',
            description: 'Select field B for comparison',
            group: 'style',
            defaultValue: "confirmContactNumber",
            validations: {
                in: [
                    { value: 'email', displayName: 'Email' },
                    { value: 'confirmEmail', displayName: 'Confirm email' },
                    { value: 'contactNumber', displayName: 'Contact number' },
                    { value: 'confirmContactNumber', displayName: 'Confirm contact number' }
                ]
            },
        }),
    },

    // Checkbox params
    checkboxInputField: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Input Field Type',
            group: 'style',
            defaultValue: "checkbox",
            validations: {
                in: [
                    { value: 'checkbox', displayName: 'Checkbox' }
                ]
            },
        }),
        customName: setAttr({
            displayName: 'Custom Field Name',
            description: "Input Field Name Value for backend processing",
            group: 'style'
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Field Name Value for backend processing',
            group: 'style',
            defaultValue: "termsConsent",
            validations: {
                in: [
                    { value: 'termsConsent', displayName: 'Terms consent' },
                    { value: 'privacyConsent', displayName: 'Privacy consent' },
                    { value: 'marketingConsent', displayName: 'Marketing consent' },
                    { value: 'custom', displayName: 'Custom' }
                ]
            },
        }),
        checkedValue: setAttr({
            displayName: 'Checked Value',
            description: 'Input Field Value for checked state',
            group: 'style'
        }),
        uncheckedValue: setAttr({
            displayName: 'Unchecked Value',
            description: 'Input Field Value for unchecked state',
            group: 'style'
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
        defaultValue: setAttr({
            displayName: 'Default Value',
            description: 'Default value of input field',
            group: 'content',
            type:'Boolean',
            defaultValue: false
        })
    },

    // Radio button params
    radioButtonInputField: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Input Field Type',
            group: 'style',
            defaultValue: "radio",
            validations: {
                in: [
                    { value: 'radio', displayName: 'Radio Button' }
                ]
            },
        }),
        customName: setAttr({
            displayName: 'Custom Field Name',
            description: "Input Field Name Value for backend processing",
            group: 'style'
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Field Name Value for backend processing',
            group: 'style',
            defaultValue: "termsConsent",
            validations: {
                in: [
                    { value: 'termsConsent', displayName: 'Terms consent' },
                    { value: 'privacyConsent', displayName: 'Privacy consent' },
                    { value: 'marketingConsent', displayName: 'Marketing consent' },
                    { value: 'custom', displayName: 'Custom' }
                ]
            },
        }),
        checkedValue: setAttr({
            displayName: 'Checked Value',
            description: 'Input Field Value for checked state',
            group: 'style'
        }),
        uncheckedValue: setAttr({
            displayName: 'Unchecked Value',
            description: 'Input Field Value for unchecked state',
            group: 'style'
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
    },

    // Dropdown input field params
    inputDropdown: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content',
            defaultValue: 'Please select an option'
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Dropdown Name Value for backend processing',
            group: 'style',
            defaultValue: "select",
            validations: {
                in: [
                    { value: 'select', displayName: 'Select' },
                    { value: 'subject', displayName: 'Subject' },
                    { value: 'purpose', displayName: 'Purpose' },
                    { value: 'custom', displayName: 'Custom' }
                ]
            },
        }),
        customName: setAttr({
            displayName: 'Custom name for field',
            group: 'content',
            defaultValue: 'Please add custom name for field'
        }),
        placeholder: setAttr({
            displayName: 'Placeholder Value',
            group: 'content',
            defaultValue: 'Please select an option'
        }),
        entryTags: setAttr({
            displayName: 'Data source tags',
            group: 'style',
            description: 'Please add content tags in comma separated'
        }),
        options: setAttr({
            displayName: 'Options list (if tags not available)',
            group: 'style',
            description: 'Please add option in JSON format',
            defaultValue: `[{"internalName":"sorting-value-1","value":"1","label":"One"},{"internalName":"sorting-value-2","value":"2","label":"Two"}]`
        }),
        helperText: setAttr({
            displayName: 'Helper Text',
            description: 'Text to help user for input value.',
            group: 'content',
            defaultValue: ''
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
    },
    // Basic Dropdown input field params
    inputBasicDropdown: {
        label: setAttr({
            displayName: 'Field Label',
            group: 'content',
            defaultValue: 'Please select an option'
        }),
        name: setAttr({
            displayName: 'Field Name',
            description: 'Input Dropdown Name Value for backend processing',
            group: 'style',
            defaultValue: "select",
            validations: {
                in: [
                    { value: 'select', displayName: 'Select' },
                    { value: 'custom', displayName: 'Custom' }
                ]
            },
        }),
        placeholder: setAttr({
            displayName: 'Placeholder Value',
            group: 'content',
            defaultValue: 'Please select an option'
        }),
        // entryTags: setAttr({
        //     displayName: 'Data source tags',
        //     group: 'style',
        //     description: 'Please add content tags in comma separated'
        // }),
        options: setAttr({
            displayName: 'Options list',
            group: 'style',
            description: 'Please add option in JSON format',
            defaultValue: `[{"internalName":"sorting-value-1","value":"1","label":"One"},{"internalName":"sorting-value-2","value":"2","label":"Two"}]`
        }),
        helperText: setAttr({
            displayName: 'Helper Text',
            description: 'Text to help user for input value.',
            group: 'content',
            defaultValue: ''
        }),
        requiredErrorMessage: setAttr({
            displayName: 'Required Field Error Message',
            description: 'Field is required.',
            group: 'content',
            defaultValue: 'Field is required.'
        }),
    },
    "link": {
        label: setAttr({
            displayName: 'Text',
            defaultValue: 'Ciick Here',
            group: "content",
        }),
        href: setAttr({
            displayName: 'URL/Href',
            defaultValue: '#',
            group: "content",
        }),
        source: setAttr({
            displayName: 'Link source',
            defaultValue: "manual",
            validations: {
                in: [
                    { value: 'manual', displayName: 'Manual(String value)' },
                    { value: 'query', displayName: 'Query' }
                ]
            },
        }),
        sourceKey: setAttr({
            displayName: 'Link source key (from: query)', // (from: query|cookie|etc.)
            description: 'The query parameter key that contains the URL',
            group: "style",
        }),
        appendToUrl: setAttr({
            displayName: 'Append to URL (if source is query)', // (if source is query|cookie|etc.)
            group: "style",
            defaultValue: "",
            description: "Value to be appended to the URL as query parameter. Example: 'ref=navlink'"
        }),
        externalUrl: setAttr({
            displayName: 'Open in new tab',
            type: 'Boolean',
            defaultValue: false
        }),
        image: setAttr({
            displayName: 'Image',
            type: 'Media',
            group: "content",
        }),
        cssClass: setAttr({
            displayName: 'Class Name',
            defaultValue: '',
            group: "content",
        }),
        iconWidth: setAttr({
            displayName: 'Image width',
            defaultValue: '30'
        }),
        iconHeight: setAttr({
            displayName: 'Image height',
            defaultValue: '30'
        }),
        enableContainer: {
            displayName: 'Droppable container',
            type: 'Boolean',
            defaultValue: false,
            group: "style",
        },
        eventName: {
            displayName: 'Event Name',
            type: 'Text',
            defaultValue: "",
            group: "style",
        },
        reload: setAttr({
            displayName: 'Reload in same tab',
            type: 'Boolean',
            defaultValue: false
        }),
        showInSection: setAttr({
            displayName: 'Show In Section',
            group: "style",
            type: 'Boolean',
            defaultValue: false
        }),
        sectionId: setAttr({
            displayName: 'Section Id',
            group: "style",
            type: 'Text'
        }),
        GTMLabel: setAttr({
            displayName: 'GTM label',
            defaultValue: "",
            group: "content",
        }),
        linkCategory: setAttr({
            displayName: 'GTM link category (facebook|instagram|etc.)',
            defaultValue: "",
            group: 'style',
            validations: {
                in: [
                    { value: '', displayName: 'Select' },
                    { value: 'Facebook', displayName: 'Facebook' },
                    { value: 'Instagram', displayName: 'Instagram' },
                    { value: 'TikTok', displayName: 'TikTok' },
                    { value: 'YouTube', displayName: 'YouTube' },
                    { value: 'Whatsapp', displayName: 'Whatsapp' },
                    { value: 'MeetingPlace', displayName: 'MeetingPlace' },
                    { value: 'IKEA', displayName: 'Ikea' },
                    { value: 'BookingEngine', displayName: 'BookingEngine' },
                    { value: 'Quiz', displayName: 'Quiz' },
                    { value: 'Offer', displayName: 'Offer' },
                    { value: 'Others', displayName: 'Others' }
                ]
            },
        })
    },
    "modalContainer": {
        id: setAttr({
            displayName: 'ID',
            type: 'Text',
            group: 'style'
        }),
        eventName: setAttr({
            displayName: 'Event name',
            type: 'Text',
            description: 'DOM event name that triggers the modal open',
            group: 'style'
        }),
        maxWidth: setAttr({
            displayName: 'Max width',
            type: 'Text',
            description: 'Modal max width',
            group: 'style',
        }),
        title: setAttr({
            displayName: 'Title',
            type: 'Text',
        }),
        subTitle: setAttr({
            displayName: 'Sub Title',
            type: 'Text',
        }),
        description: setAttr({
            displayName: 'Description',
            type: 'RichText',
            group: 'content'
        }),
        successMessage: setAttr({
            displayName: 'Success message',
            description: 'Message displayed when form is submitted',
            type: 'Text'
        }),
        modalVariant: setAttr({
            displayName: 'Modal Size',
            description: 'Modal Variant',
            group: 'style',
            defaultValue: 'default',
            validations: {
                in: [
                    { value: 'default', displayName: 'Default' },
                    { value: 'futures', displayName: 'Futures' },
                ]
            },
        }),
        variant: setAttr({
            displayName: 'Variant',
            description: 'Modal Variant',
            group: 'style',
            defaultValue: 'default',
            validations: {
                in: [
                    { value: 'bg-[#FFFFFF]', displayName: 'Default' },
                    { value: 'bg-[#ffdb00]', displayName: 'Yellow' },
                    { value: 'bg-[#0f102a]', displayName: 'Dark Blue' },
                ]
            },
        }),
        // closeButtonColor: setAttr({
        //     displayName: 'Variant',
        //     description: 'Modal Variant',
        //     group: 'style',
        //     defaultValue: 'default',
        //     validations: {
        //         in: [
        //             { value: '#474747', displayName: 'Default' },
        //             { value: '#FFFFFF', displayName: 'White' },
        //             { value: '#ef9617', displayName: 'Orange' },
        //         ]
        //     },
        // }),
        logo: setAttr({
            displayName: 'Logo',
            type: 'Media',
            group: 'content'
        }),
        showLogo: setAttr({
            displayName: 'Show Logo',
            type: 'Boolean',
            defaultValue: false
        }),
        // scrollable: setAttr({
        //     displayName: 'Scrollable',
        //     type: 'Boolean',
        //     defaultValue: true
        // }),
        modalOntimer: setAttr({
            displayName: 'Show After Time(s)',
            description: "Value to be greater than equal to 1",
            type: 'Number',
            defaultValue: 0,
        }),
    },
    "fileUpload": {
        label: setAttr({
            displayName: 'Label',
            group: 'content'
        }),
        capture: setAttr({
            displayName: 'Capture',
            group: 'style',
            defaultValue: 'none',
            validations: {
                in: [
                    { value: 'none', displayName: 'No Camera' },
                    { value: 'environment', displayName: 'Rear Camera' },
                    { value: 'user', displayName: 'Front Camera' }
                ]
            },

        }),
        accept: setAttr({
            displayName: 'Accept',
            group: 'content'
        })
    },
    "colorPalette": {
        noOfSlots: setAttr({
            displayName: 'Number of Slots',
            defaultValue: 1,
            group: 'style',
            type: 'Number'
        }),
        enableVerticalStack: setAttr({
            displayName: 'Stack Vertically',
            defaultValue: false,
            group: 'style',
            type: 'Boolean'
        }),
        btn_label: setAttr({
            displayName: 'Button Label',
            defaultValue: "Change Palette",
            group: 'content',
            type: 'Text'
        }),
        btn_variant: setAttr({
            displayName: 'Button Variant',
            validations: {
                in: [
                    { value: 'primary', displayName: 'Primary' },
                    { value: 'secondary', displayName: 'Secondary' },
                    { value: 'ghost', displayName: 'Ghost' },
                ]
            },
            defaultValue: 'primary',
        }),
        btn_size: setAttr({
            displayName: 'Button Size',
            validations: {
                in: [
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' },
                ]
            },
            defaultValue: 'm',
        }),
        btn_hide: setAttr({
            displayName: 'Button Hide',
            defaultValue: false,
            group: 'style',
            type: 'Boolean'
        }),
        btn_position: setAttr({
            displayName: 'Button Position',
            defaultValue: "center",
            group: 'style',
            validations: {
                in: [
                    { value: 'center', displayName: 'Center' },
                    { value: 'start', displayName: 'Left' },
                    { value: 'end', displayName: 'Right' },
                ]
            },
        }),
    },
    "iframeWrapper": {
        title: setAttr({
            displayName: 'Title',
            group: 'content'
        }),
        categoryId: setAttr({
            displayName: 'One Trust Category Id',
            group: 'content'
        }),
        src: setAttr({
            displayName: 'Source',
            group: 'content'
        }),
        allowFullScreen: setAttr({
            displayName: 'Allow Full Screen',
            type: 'Boolean',
            group: 'content'
        }),
        loading: setAttr({
            displayName: 'Loading',
            group: 'content'
        }),
        acceptCookieMsg: setAttr({
            displayName: 'Accept Cookie msg',
            group: 'content',
            defaultValue: "Please accept cookies to view. If you do not want to accept cookies try"
        })
    },
    "instagramEmbed": {
        url: setAttr({
            displayName: 'Link',
            group: 'content'
        }),
        showCaption: setAttr({
            displayName: 'Show Caption',
            type: 'Boolean',
            group: 'content',
            defaultValue: false
        })
    },
    "interactiveImage": {
        areas: setAttr({
            displayName: 'Areas',
            group: 'style',
        }),
        // src: setAttr({
        //     displayName: 'Source',
        //     group: 'content',
        //     type: "Media"
        // }),
        src: setAttr({
            displayName: 'Image source',
            type: 'Media',
            group: 'content',
            validations: {
                required: true,
                pattern: '^https?://.*\\.(jpg|jpeg|png|webp|gif|svg)$'
            }
        }),
        damSrc: setAttr({
            displayName: 'DAM Image source',
            type: 'Object',
            group: 'content'
        }),
        damThumbnail: setAttr({
            displayName: 'DAM Thumbnail source',
            type: 'Object',
            group: 'content'
        }),
        imageWidth: setAttr({
            displayName: 'Image width',
            group: 'style',
            type: 'Text',
        }),
        imageHeight: setAttr({
            displayName: 'Image height',
            group: 'style',
            type: 'Text',
        }),
        eventName: setAttr({
            displayName: "Event name",
            description: "Event that will be triggered on clicking the image",
            group: "content",
            type: "Text"
        })
    },
    "media": {
        media: setAttr({
            displayName: 'Media Source',
            type: 'Media',
            group: 'content'
        })
    },
    "overlay": {
        zIndex: setAttr({
            displayName: 'Z-Index',
            type: 'Number',
            group: 'content'
        })
    },
    "accordion": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        heading: setAttr({
            type: "Text",
            displayName: 'Heading',
            defaultValue: 'Add your heading here',
            group: 'content'
        }),
        fontStyle: setAttr({
            displayName: 'Font Family',
            defaultValue: 'default',
            validations: {
                in: [
                    { value: 'default', displayName: 'Default' },
                    { value: 'livelyHeadline', displayName: 'Lively Headline' },
                    { value: 'notoIkea', displayName: 'Noto Ikea' },
                    { value: 'micro', displayName: 'Micro 5' },
                ]
            }
        }),
        headerFontSize: setAttr({
            displayName: 'Font Size',
            validations: {
                in: [
                    { displayName: "Extra Extra Small", value: "xxs" },
                    { displayName: "Extra Small", value: "xs" },
                    { displayName: "Small", value: "s" },
                    { displayName: "Medium", value: "m" },
                    { displayName: "Large", value: "l" },
                    { displayName: "Extra Large", value: "xl" },
                ]
            },
            defaultValue: 'l',
        }),
        groupName: {
            displayName: 'Group Name',
            type: 'Text',
            defaultValue: "",
            group: "style",
        },
    },
    "container": {
        // zIndex: setAttr({
        //     displayName: 'Z-Index',
        //     type: 'Number'
        // }),
        bgMedia: setAttr({
            displayName: 'Background Media',
            type: 'Media',
            group: 'content'
        }),
        // position: setAttr({
        //     displayName: 'Position',
        //     description: 'Position Property for overlay',
        //     defaultValue: 'l',
        //     validations: {
        //       in: [
        //         { value: 'relative', displayName: 'Relative' },
        //         { value: 'absolute', displayName: 'Absolute' },
        //         { value: 'sticky', displayName: 'Sticky' },
        //         { value: 'xl', displayName: 'Extra Large' },
        //       ]
        //     },
        // }),
        // top: setAttr({
        //     displayName: 'Top Position',
        //     type: 'Number'
        // }),
        // right: setAttr({
        //     displayName: 'Right Position',
        //     type: 'Number'
        // }),
        // bottom: setAttr({
        //     displayName: 'Bottom Position',
        //     type: 'Number'
        // }),
        // left: setAttr({
        //     displayName: 'Left Position',
        //     type: 'Number'
        // }),
        // imagePositionX: setAttr({
        //     displayName: 'Image horizontal position',
        //     group: 'style',
        //     type: 'Text',
        //     defaultValue: '50%',
        // }),
        // imagePositionY: setAttr({
        //     displayName: 'Image vertical position',
        //     group: 'style',
        //     type: 'Text',
        //     defaultValue: '50%',
        // }),
        bgSize: setAttr({
            displayName: 'Background Size',
            description: 'Background Size for Baseplate Container. "100% 100%" applies on width and height respectively',
            defaultValue: 'cover',
            validations: {
                in: [
                    { value: 'auto', displayName: 'Auto' },
                    { value: 'initial', displayName: 'Initial' },
                    { value: 'contain', displayName: 'Contain' },
                    { value: 'cover', displayName: 'Cover' },
                    { value: '100% 100%', displayName: '100% 100%' },
                    { value: '100% auto', displayName: '100% Auto' },
                    { value: 'auto 100%', displayName: 'Auto 100%' },
                ]
            },
        }),
        bgPosition: setAttr({
            displayName: 'Background Position',
            description: 'Background Position for the Baseplate Container. "Center Center" applies to Vertical and Horizontal respectively',
            defaultValue: 'center center',
            validations: {
                in: [
                    { value: 'center center', displayName: 'Center' },
                    { value: 'center left', displayName: 'Center Left' },
                    { value: 'center right', displayName: 'Center Right' },
                    { value: 'left top', displayName: 'Top Left' },
                    { value: 'right top', displayName: 'Top Right' },
                    { value: 'center top', displayName: 'Top Center' },
                    { value: 'left bottom', displayName: 'Bottom Left' },
                    { value: 'right bottom', displayName: 'Bottom Right' },
                    { value: 'center bottom', displayName: 'Bottom Center' },
                ]
            },
        }),
        // cssClassName: setAttr({
        //     displayName: 'Css Class',
        //     group: 'style'
        // }),
        name: setAttr({
            displayName: 'Name',
            group: 'style'
        }),
    },
    "stickyContainer": {
        position: setAttr({
            displayName: 'Position',
            description: 'Position Property for the Sticky Container',
            defaultValue: 'top-left',
            validations: {
                in: [
                    { value: 'top-left', displayName: 'Top Left' },
                    { value: 'top-right', displayName: 'Top Right' },
                    { value: 'bottom-left', displayName: 'Bottom Left' },
                    { value: 'bottom-right', displayName: 'Bottom Right' },
                ]
            },
        }),
        hide: setAttr({
            displayName: "Hide",
            type: "Boolean",
            description: "Select if element needs to be hidden.",
            group: 'style',
            defaultValue: false
        }),
        // Top: setAttr({
        //     displayName: 'Top',
        //     description: 'Top Property for the content in Sticky Container, to start content from top',
        //     defaultValue: 'top-4',
        //     validations: {
        //       in: [
        //         { value: 'top-1', displayName: '1' },
        //         { value: 'top-2', displayName: '2' },
        //         { value: 'top-3', displayName: '3' },
        //         { value: 'top-4', displayName: '4' },
        //         { value: 'top-5', displayName: '5' },
        //         { value: 'top-6', displayName: '6' },
        //         { value: 'top-7', displayName: '7' },
        //         { value: 'top-8', displayName: '8' }
        //       ]
        //     },
        // }),
        // Right: setAttr({
        //     displayName: 'Right',
        //     description: 'Right Property for the content in Sticky Container, to end content',
        //     defaultValue: 'right-4',
        //     validations: {
        //       in: [
        //         { value: 'right-1', displayName: '1' },
        //         { value: 'right-2', displayName: '2' },
        //         { value: 'right-3', displayName: '3' },
        //         { value: 'right-4', displayName: '4' },
        //         { value: 'right-5', displayName: '5' },
        //         { value: 'right-6', displayName: '6' },
        //         { value: 'right-7', displayName: '7' },
        //         { value: 'right-8', displayName: '8' }
        //       ]
        //     },
        // }),
        // Bottom: setAttr({
        //     displayName: 'Bottom',
        //     description: 'Bottom Property for the content in Sticky Container, to end content',
        //     defaultValue: 'bottom-4',
        //     validations: {
        //       in: [
        //         { value: 'bottom-1', displayName: '1' },
        //         { value: 'bottom-2', displayName: '2' },
        //         { value: 'bottom-3', displayName: '3' },
        //         { value: 'bottom-4', displayName: '4' },
        //         { value: 'bottom-5', displayName: '5' },
        //         { value: 'bottom-6', displayName: '6' },
        //         { value: 'bottom-7', displayName: '7' },
        //         { value: 'bottom-8', displayName: '8' }
        //       ]
        //     },
        // }),
        // Left: setAttr({
        //     displayName: 'Left',
        //     description: 'Left Property for the content in Sticky Container, to start content from left',
        //     defaultValue: 'left-4',
        //     validations: {
        //       in: [
        //         { value: 'left-1', displayName: '1' },
        //         { value: 'left-2', displayName: '2' },
        //         { value: 'left-3', displayName: '3' },
        //         { value: 'left-4', displayName: '4' },
        //         { value: 'left-5', displayName: '5' },
        //         { value: 'left-6', displayName: '6' },
        //         { value: 'left-7', displayName: '7' },
        //         { value: 'left-8', displayName: '8' }
        //       ]
        //     },
        // }),
    },
    "floatingContainer": {
        position: setAttr({
            displayName: 'Position',
            description: 'Position Property for the Fixed Container',
            defaultValue: 'top-left',
            validations: {
                in: [
                    { value: 'top-left', displayName: 'Top Left' },
                    { value: 'top-center', displayName: 'Top Center' },
                    { value: 'top-right', displayName: 'Top Right' },
                    { value: 'bottom-left', displayName: 'Bottom Left' },
                    { value: 'bottom-center', displayName: 'Bottom Center' },
                    { value: 'bottom-right', displayName: 'Bottom Right' },
                    { value: 'left-center', displayName: 'Center Left' },
                    { value: 'center', displayName: 'Center' },
                    { value: 'right-center', displayName: 'Center Right' },
                    { value: 'clicked area', displayName: 'Clicked Area' },
                ]
            }

        }),
        top: setAttr({
            displayName: 'Top',
            description: 'Top Property for the content in Sticky Container, to start content from top',
            defaultValue: 'top-4',
            validations: {
                in: [
                    { value: 'top-0', displayName: '0' },
                    { value: 'top-1', displayName: '1' },
                    { value: 'top-2', displayName: '2' },
                    { value: 'top-3', displayName: '3' },
                    { value: 'top-4', displayName: '4' },
                    { value: 'top-5', displayName: '5' },
                    { value: 'top-6', displayName: '6' },
                    { value: 'top-7', displayName: '7' },
                    { value: 'top-8', displayName: '8' },
                    { value: 'top-12', displayName: '12' },
                    { value: 'top-16', displayName: '16' }

                ]
            },
        }),
        right: setAttr({
            displayName: 'Right',
            description: 'Right Property for the content in Sticky Container, to end content',
            defaultValue: 'right-4',
            validations: {
                in: [
                    { value: 'right-0', displayName: '0' },
                    { value: 'right-1', displayName: '1' },
                    { value: 'right-2', displayName: '2' },
                    { value: 'right-3', displayName: '3' },
                    { value: 'right-4', displayName: '4' },
                    { value: 'right-5', displayName: '5' },
                    { value: 'right-6', displayName: '6' },
                    { value: 'right-7', displayName: '7' },
                    { value: 'right-8', displayName: '8' }
                ]
            },
        }),
        bottom: setAttr({
            displayName: 'Bottom',
            description: 'Bottom Property for the content in Sticky Container, to end content',
            defaultValue: 'bottom-4',
            validations: {
                in: [
                    { value: 'bottom-0', displayName: '0' },
                    { value: 'bottom-1', displayName: '1' },
                    { value: 'bottom-2', displayName: '2' },
                    { value: 'bottom-3', displayName: '3' },
                    { value: 'bottom-4', displayName: '4' },
                    { value: 'bottom-5', displayName: '5' },
                    { value: 'bottom-6', displayName: '6' },
                    { value: 'bottom-7', displayName: '7' },
                    { value: 'bottom-8', displayName: '8' }
                ]
            },
        }),
        left: setAttr({
            displayName: 'Left',
            description: 'Left Property for the content in Sticky Container, to start content from left',
            defaultValue: 'left-4',
            validations: {
                in: [
                    { value: 'left-0', displayName: '0' },
                    { value: 'left-1', displayName: '1' },
                    { value: 'left-2', displayName: '2' },
                    { value: 'left-3', displayName: '3' },
                    { value: 'left-4', displayName: '4' },
                    { value: 'left-5', displayName: '5' },
                    { value: 'left-6', displayName: '6' },
                    { value: 'left-7', displayName: '7' },
                    { value: 'left-8', displayName: '8' }
                ]
            },
        }),
        type: setAttr({
            displayName: 'Variant',
            group: "style",
            defaultValue: "fixed",
            description: 'Select behaviour of container : can be fixed to position or placed relatively.',
            validations: {
                in: [
                    { value: 'initial', displayName: 'Initial' },
                    { value: 'inherit', displayName: 'Inherit' },
                    { value: 'sticky', displayName: 'Sticky' },
                    { value: 'static', displayName: 'Static' },
                    { value: 'relative', displayName: 'Relative' },
                    { value: 'absolute', displayName: 'Absolute' },
                    { value: 'fixed', displayName: 'Fixed' },
                ]
            },
        }),
        closeEventName: setAttr({
            displayName: 'Hide Event Name',
            description: 'Name of the event that will hide the container',
            group: 'style'
        }),
        openEventName: setAttr({
            displayName: 'Show Event Name',
            description: 'Name of the event that will show the container',
            group: 'style'
        }),
        display: setAttr({
            displayName: 'Display',
            group: "style",
            description: 'Select if container is hidden or shown on event.',
            defaultValue: "show",
            validations: {
                in: [
                    { value: 'show', displayName: 'Show' },
                    { value: 'hide', displayName: 'Hide' },
                    { value: 'event', displayName: 'Show on event' },
                ]
            },
        }),
        id: setAttr({
            displayName: 'Id',
            group: "content",
        })
    },
    "richTextBox": {
        textContent: setAttr({
            displayName: 'Rich Text Content',
            type: 'RichText',
            group: 'content'
        })
    },
    "image": {
        width: setAttr({
            displayName: 'Image width',
            type: 'Number',
            defaultValue: 200
        }),
        height: setAttr({
            displayName: 'Image height',
            type: 'Number',
            defaultValue: 200
        }),
        cornerRadius: setAttr({
            displayName: 'Corner Radius',
            type: 'Text',
            defaultValue: '0px'
        }),
        alt: setAttr({
            displayName: 'Alt text',
            defaultValue: 'img',
            group: 'content',
            validations: {
                maxLength: 150
            }
        }),
        src: setAttr({
            displayName: 'Image source',
            type: 'Media',
            group: 'content',
            validations: {
                required: true,
                pattern: '^https?://.*\\.(jpg|jpeg|png|webp|gif|svg)$'
            }
        }),
        damSrc: setAttr({
            displayName: 'DAM Image source',
            type: 'Object',
            group: 'content'
        }),
        damThumbnail: setAttr({
            displayName: 'DAM Thumbnail source',
            type: 'Object',
            group: 'content'
        }),
        priority: setAttr({
            displayName: 'Preload',
            type: 'Boolean',
            defaultValue: true
        }),
        quality: setAttr({
            displayName: 'Image quality btween 1 to 100',
            type: 'Number',
            defaultValue: 100
        }),
        blurOnLoad: setAttr({
            displayName: 'Show blurred image on load',
            type: 'Boolean',
            defaultValue: true
        }),
        fill: setAttr({
            displayName: 'Fill',
            type: 'Boolean',
            defaultValue: false
        }),
        progressive: setAttr({
            displayName: 'Make it progressive',
            type: 'Boolean',
            defaultValue: false
        }),
        dataAosOnce: setAttr({
            displayName: 'Animate once',
            type: 'Boolean',
            defaultValue: false
        }),
        dataAosDuration: setAttr({
            displayName: 'Animation duration',
            type: 'Number',
            defaultValue: 1500
        }),
        dataAosDelay: setAttr({
            displayName: 'Animation delay',
            type: 'Number',
            defaultValue: 300
        }),
        dataAosOffset: setAttr({
            displayName: 'Offset for animation item',
            type: 'Number',
            defaultValue: 0
        }),
        dataAosEasing: setAttr({
            displayName: 'Animation easing function',
            defaultValue: 'ease-in-out',
            validations: {
                in: [
                    { value: 'linear', displayName: 'Linear' },
                    { value: 'ease', displayName: 'Ease' },
                    { value: 'ease-in', displayName: 'Ease in' },
                    { value: 'ease-out', displayName: 'Ease out' },
                    { value: 'ease-in-out', displayName: 'Ease in out' },
                    { value: 'ease-in-back', displayName: 'Ease in back' },
                    { value: 'ease-out-back', displayName: 'Ease out back' },
                    { value: 'ease-in-out-back', displayName: 'Ease in out back' },
                    { value: 'ease-in-sine', displayName: 'Ease in sine' },
                    { value: 'ease-out-sine', displayName: 'Ease out sine' },
                    { value: 'ease-in-out-sine', displayName: 'Ease in out sine' },
                    { value: 'ease-in-quad', displayName: 'Ease in quad' },
                    { value: 'ease-out-quad', displayName: 'Ease out quad' },
                    { value: 'ease-in-out-quad', displayName: 'Ease in out quad' },
                    { value: 'ease-in-cubic', displayName: 'Ease in cubic' },
                    { value: 'ease-out-cubic', displayName: 'Ease out cubic' },
                    { value: 'ease-in-out-cubic', displayName: 'Ease in out cubic' },
                    { value: 'ease-in-quart', displayName: 'Ease in quart' },
                    { value: 'ease-out-quart', displayName: 'Ease out quart' },
                    { value: 'ease-in-out-quart', displayName: 'Ease in out quart' }
                ]
            }
        }),
        dataAosAnchorPlacement: setAttr({
            displayName: 'Animation control anchor point',
            defaultValue: 'top-bottom',
            validations: {
                in: [
                    { value: 'top-bottom', displayName: 'Top of element → Bottom of viewport' },
                    { value: 'top-center', displayName: 'Top of element → Center of viewport' },
                    { value: 'top-top', displayName: 'Top of element → Top of viewport' },
                    { value: 'center-bottom', displayName: 'Center of element → Bottom of viewport' },
                    { value: 'center-center', displayName: 'Center of element → Center of viewport' },
                    { value: 'center-top', displayName: 'Center of element → Top of viewport' },
                    { value: 'bottom-bottom', displayName: 'Bottom of element → Bottom of viewport' },
                    { value: 'bottom-center', displayName: 'Bottom of element → Center of viewport' },
                    { value: 'bottom-top', displayName: 'Bottom of element → Top of viewport' }
                ]
            }
        }),
        dataAos: setAttr({
            displayName: 'Data Aos',
            defaultValue: "",
            validations: {
                in: [
                    { value: '', displayName: 'None' },
                    { value: 'fade', displayName: 'Fade' },
                    { value: 'fade-up', displayName: 'Fade up' },
                    { value: 'fade-down', displayName: 'Fade down' },
                    { value: 'fade-left', displayName: 'Fade left' },
                    { value: 'fade-right', displayName: 'Fade right' },
                    { value: 'fade-up-right', displayName: 'Fade up right' },
                    { value: 'fade-up-left', displayName: 'Fade up left' },
                    { value: 'fade-down-right', displayName: 'Fade down right' },
                    { value: 'fade-down-left', displayName: 'Fade down left' },
                    { value: 'flip-up', displayName: 'Flip up' },
                    { value: 'flip-down', displayName: 'Flip down' },
                    { value: 'flip-left', displayName: 'Flip left' },
                    { value: 'flip-right', displayName: 'Flip right' },
                    { value: 'slide-up', displayName: 'Slide up' },
                    { value: 'slide-down', displayName: 'Slide down' },
                    { value: 'slide-left', displayName: 'Slide left' },
                    { value: 'slide-right', displayName: 'Slide right' },
                    { value: 'zoom-in', displayName: 'Zoom in' },
                    { value: 'zoom-in-up', displayName: 'Zoom in up' },
                    { value: 'zoom-in-down', displayName: 'Zoom in down' },
                    { value: 'zoom-in-left', displayName: 'Zoom in left' },
                    { value: 'zoom-in-right', displayName: 'Zoom in right' },
                    { value: 'zoom-out', displayName: 'Zoom out' },
                    { value: 'zoom-out-up', displayName: 'Zoom out up' },
                    { value: 'zoom-out-down', displayName: 'Zoom out down' },
                    { value: 'zoom-out-left', displayName: 'Zoom out left' },
                    { value: 'zoom-out-right', displayName: 'Zoom out right' }
                ]
            }
        }),
        objectFit: setAttr({
            displayName: 'Fit image in container',
            defaultValue: 'contain',
            validations: {
                in: [
                    { value: 'contain', displayName: 'Contain' },
                    { value: 'cover', displayName: 'Cover' }
                ]
            },
        }),
        overflow: setAttr({
            displayName: 'Overflow',
            defaultValue: 'overflow-auto',
            validations: {
                in: [
                    { value: 'overflow-auto', displayName: 'Auto' },
                    { value: 'overflow-hidden', displayName: 'Hidden' },
                    { value: 'overflow-visible', displayName: 'Visible' },
                    { value: 'overflow-scroll', displayName: 'Scroll' },
                    { value: 'overflow-x-auto', displayName: 'X Auto' },
                    { value: 'overflow-y-auto', displayName: 'Y Auto' },
                    { value: 'overflow-x-hidden', displayName: 'X Hidden' },
                    { value: 'overflow-y-hidden', displayName: 'Y Hidden' },
                    { value: 'overflow-x-visible', displayName: 'X Visible' },
                    { value: 'overflow-y-visible', displayName: 'Y Visible' },
                    { value: 'overflow-x-scroll', displayName: 'X Scroll' },
                    { value: 'overflow-y-scroll', displayName: 'Y Scroll' }
                ]
            }
        })
    },
    "columnTextImage": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        heroTitle: setAttr({
            displayName: 'Title',
            defaultValue: 'Add your title here',
            group: 'content'
        }),
        subTitle: setAttr({
            displayName: 'Subtitle',
            type: 'RichText',
            defaultValue: { data: 'Add your subtitle here' },
            group: 'content'
        }),
        description: setAttr({
            displayName: 'Description',
            type: 'RichText',
            group: 'content'
        }),
        image: setAttr({
            displayName: 'Media',
            type: 'Media',
            group: 'content'
        }),
        heroTitleSize: setAttr({
            displayName: 'Title size',
            description: 'The size of the her title',
            defaultValue: 'l',
            validations: {
                in: [
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' },
                ]
            },
        })
    },
    "videoCard": {
        title: setAttr({
            displayName: 'Title',
            defaultValue: 'Add your title here',
            group: 'content'
        }),
        subtitle: setAttr({
            displayName: 'Subtitle',
            defaultValue: 'Add your subtitle here',
            group: 'content'
        }),
        description: setAttr({
            displayName: 'Description',
            type: 'RichText',
            group: 'content'
        }),
        maxWidth: setAttr({
            displayName: 'Card width',
            group: 'style',
            validations: {
                in: [
                    { value: '100%', displayName: 'Full' },
                    { value: 'max-content', displayName: 'Fit' },
                ],
            },
        }),
        roundedCorners: setAttr({
            displayName: 'Rounded corners',
            type: 'Boolean',
            group: 'style',
        }),
        hideText: setAttr({
            displayName: 'Hide text',
            type: 'Boolean',
            group: 'style',
            defaultValue: false,
        }),
        eventName: setAttr({
            displayName: 'Open Modal Event name',
            group: 'style',
            description: 'The event tha should be triggered on click',
        }),
        centerTextVertically: setAttr({
            displayName: 'Center text vertically',
            type: 'Boolean',
            group: 'style',
            defaultValue: false,
        }),
        pauseable: setAttr({
            displayName: 'Be able to pause',
            type: 'Boolean',
            group: 'style',
            defaultValue: false,
        }),
        autoPlay: setAttr({
            displayName: 'Auto play',
            type: 'Boolean',
            group: 'style',
            defaultValue: false,
        }),
        titleFontSize: setAttr({
            displayName: 'Title Font Size',
            validations: {
                in: [
                    { displayName: "Small", value: "s" },
                    { displayName: "Medium", value: "m" },
                    { displayName: "Large", value: "l" },
                    { displayName: "Extra Large", value: "xl" },
                ]
            },
            defaultValue: 'm',
        }),
        subtitleFontSize: setAttr({
            displayName: 'Subtitle Font Size',
            validations: {
                in: [
                    { displayName: "Small", value: "s" },
                    { displayName: "Medium", value: "m" },
                    { displayName: "Large", value: "l" },
                    { displayName: "Extra Large", value: "xl" },
                ]
            },
            defaultValue: 's',
        }),
        bodyFontSize: setAttr({
            displayName: 'Body Font Size',
            validations: {
                in: [
                    { displayName: "Extra Extra Small", value: "xxs" },
                    { displayName: "Extra Small", value: "xs" },
                    { displayName: "Small", value: "s" },
                    { displayName: "Medium", value: "m" },
                    { displayName: "Large", value: "l" },
                    { displayName: "Extra Large", value: "xl" },
                ]
            },
            defaultValue: 'l',
        }),
        image: setAttr({
            displayName: 'Placeholder image',
            type: 'Media',
            group: 'content',
        }),
        video: setAttr({
            displayName: 'Video',
            type: 'Media',
            group: 'content',
        }),
        mobileVideo: setAttr({
            displayName: 'Mobile Video',
            type: 'Media',
            group: 'content'
        }),
        videoPosition: setAttr({
            displayName: 'Video position',
            group: 'style',
            defaultValue: 'Normal',
            validations: {
                in: [
                    { value: 'Normal', displayName: 'Normal' },
                    { value: 'LeftEdge', displayName: 'Left edge' },
                ],
            },
        }),
        videoWidth: setAttr({
            displayName: 'Video width',
            group: 'style',
            type: 'Text',
        }),
        videoHeight: setAttr({
            displayName: 'Video height',
            group: 'style',
            type: 'Text',
        }),
        videoWrapperWidth: setAttr({
            displayName: 'Video wrapper width',
            group: 'style',
            type: 'Text',
        }),
        videoWrapperHeight: setAttr({
            displayName: 'Video wrapper height',
            group: 'style',
            type: 'Text',
        }),
        videoStartViewX: setAttr({
            displayName: 'Video left offset',
            group: 'style',
            type: 'Text',
        }),
        videoStartViewY: setAttr({
            displayName: 'Video top offset',
            group: 'style',
            type: 'Text',
        }),
        // videoBackgroundColor: setAttr({
        //     displayName: 'Video background color',
        //     description:
        //         'Color of the background behind the image. Occurrs when image is positioned beyond the wrapper',
        //     defaultValue: 'transparent',
        //     group: 'style',
        //     type: 'Text',
        // }),
        // secondaryBackground: setAttr({
        //     displayName: 'Secondary Background Color',
        //     description:
        //         'Toggle between primary and secondary Background Colors',
        //     defaultValue: false,
        //     group: 'style',
        //     type: 'Boolean',
        // }),
        cardBackgroundColor: setAttr({
            displayName: 'Background color',
            validations: {
                in: [
                    { displayName: "Yellow", value: "#FFDB00" },
                    { displayName: "White", value: "#FFFFFF" },
                    { displayName: "Dark", value: "#1A1A1A" },
                    { displayName: "Light-Brown", value: "#F7F4EF" },
                    { displayName: "Dark-Brown", value: "#EAE3DA" },
                    { displayName: "Blue", value: "#B0D7EC" },
                    { displayName: "Dark-Blue", value: "#0f102a" },
                    { displayName: "Coral-Blue", value: "#B6D9ED" },
                    { displayName: "Grey", value: "#E0E0E0" },
                    { displayName: "Sea-Mist", value: "#C0DDCC" },
                ]
            },
            defaultValue: '#FFFFFF',
        }),
        hideButton: setAttr({
            displayName: 'Hide button',
            group: 'style',
            type: 'Boolean',
        }),
        playButtonPosition: setAttr({
            displayName: 'Play Button Position',
            validations: {
                in: [
                    { value: "center", displayName: "Center (default)" },
                    { value: "bottom-left", displayName: "Bottom Left" },
                    { value: "top-right", displayName: "Top Right" },
                    { value: "none", displayName: "None / Hide" },
                ]
            },
            defaultValue: 'center',
        }),

        btn1_label: setAttr({
            displayName: 'Button Label',
            defaultValue: 'Submit',
            group: 'content',
        }),
        btn1_icon: setAttr({
            displayName: 'Button Icon',
            defaultValue: 'Placeholder',
            validations: {
                in: [
                    { value: "Placeholder", displayName: "Placeholder" },
                    { value: "Close", displayName: "Close" },
                    { value: "AwardStar", displayName: "AwardStar" },
                    { value: "Clean", displayName: "Clean" },
                    { value: "Error", displayName: "Error" },
                    { value: "FoodTray", displayName: "FoodTray" },
                    { value: "GridDividers", displayName: "GridDividers" },
                    { value: "FurnitureRecycle", displayName: "FurnitureRecycle" },
                    { value: "HandHoldingDollar", displayName: "HandHoldingDollar" },
                    { value: "HandFreeShopping", displayName: "HandFreeShopping" },
                    { value: "HomeDashStar", displayName: "HomeDashStar" },
                    { value: "Facebook", displayName: "Facebook" },
                    { value: "Instagram", displayName: "Instagram" },
                    { value: "Linkedin", displayName: "Linkedin" },
                    { value: "YouTube", displayName: "YouTube" },
                    { value: "Tripadvisor", displayName: "Tripadvisor" },
                    { value: "RecyclingTriangle", displayName: "RecyclingTriangle" },
                    { value: "RecyclingTag", displayName: "RecyclingTag" },
                    { value: "SustainableIdeas", displayName: "SustainableIdeas" },
                    { value: "SustainableChoice", displayName: "SustainableChoice" },
                    { value: "WaterRecycle", displayName: "WaterRecycle" },
                    { value: "Rent", displayName: "Rent" },
                    { value: "Route", displayName: "Route" },
                    { value: "Success", displayName: "Success" },
                    { value: "Warning", displayName: "Warning" },
                    { value: "Security", displayName: "Security" },
                    { value: "SignsDirection", displayName: "SignsDirection" },
                    { value: "Store", displayName: "Store" },
                    { value: "UserStar", displayName: "UserStar" },
                    { value: "UsersGroup", displayName: "UsersGroup" },
                    { value: "Check", displayName: "Check" },
                    { value: "Microphone", displayName: "Microphone" },
                ]
            }
        }),
        btn1_iconPosition: setAttr({
            displayName: 'Icon Position',
            validations: {
                in: [
                    { value: 'hide', displayName: 'None / Hide' },
                    { value: 'top', displayName: 'Top' },
                    { value: 'right', displayName: 'Right' },
                    { value: 'left', displayName: 'Left' },
                ]
            },
            defaultValue: 'hide',
        }),
        btn1_variant: setAttr({
            displayName: 'Button Variant',
            validations: {
                in: [
                    { value: 'primary', displayName: 'Primary' },
                    { value: 'secondary', displayName: 'Secondary' },
                    { value: 'ghost', displayName: 'Ghost' },
                ]
            },
            defaultValue: 'primary',
        }),
        btn1_size: setAttr({
            displayName: 'Button Size',
            validations: {
                in: [
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                ]
            },
            defaultValue: 'm',
        }),
        btn1_action: setAttr({
            displayName: 'Button Event Name',
            description: 'The event tha should be triggered on click',
        }),
        buttonUrl: setAttr({
            displayName: 'Button URL',
            description: 'Link where clicking the button should direct',
            type: 'Text',
        }),
        linkTargetBlank: setAttr({
            displayName: 'Open link in new tab',
            type: 'Boolean',
        }),
    },
    "editorialSlider": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        title: setAttr({
            displayName: 'Title',
            defaultValue: 'Add your title here',
            group: 'content'
        }),
        description: setAttr({
            displayName: 'Description',
            type: 'RichText',
            group: 'content'
        }),
        image: setAttr({
            displayName: 'Image',
            type: 'Media',
            group: 'content'
        }),
        badge: setAttr({
            displayName: 'Badge',
            type: 'Media',
            group: 'content'
        }),
    },
    "cardImage": {
        hideCard: setAttr({
            displayName: 'Hide Image Card',
            type: 'Boolean',
            defaultValue: false
        }),
        hideMedia: setAttr({
            displayName: 'Hide Media',
            type: 'Boolean',
            defaultValue: false
        }),
        hideText: setAttr({
            displayName: 'Hide Text',
            type: 'Boolean',
            defaultValue: false
        }),
        linkTargetBlank: setAttr({
            displayName: 'Open link in new tab',
            type: 'Boolean',
        }),
        imageBackgroundColor: setAttr({
            displayName: 'Media background color',
            validations: {
                in: [
                    { displayName: "Transparent", value: "#FFFFFF00" },
                    { displayName: "Yellow", value: "#FFDB00" },
                    { displayName: "White", value: "#FFFFFF" },
                    { displayName: "Dark", value: "#1A1A1A" },
                    { displayName: "Light-Brown", value: "#F7F4EF" },
                    { displayName: "Dark-Brown", value: "#EAE3DA" },
                    { displayName: "Blue", value: "#B0D7EC" },
                    { displayName: "Dark-Blue", value: "#0f102a" },
                    { displayName: "Coral-Blue", value: "#B6D9ED" },
                    { displayName: "Grey", value: "#E0E0E0" },
                    { displayName: "Sea-Mist", value: "#C0DDCC" },
                ]
            },
            defaultValue: '#FFFFFF',
        }),
        horizontalImageAlign: setAttr({
            displayName: 'Horizontal image alignment',
            group: 'style',
            defaultValue: 'justify-items-center',
            validations: {
                in: [
                    { value: 'justify-items-start', displayName: 'Left' },
                    { value: 'justify-items-center', displayName: 'Center' },
                    { value: 'justify-items-end', displayName: 'Right' }
                ],
            },
        }),
        image: setAttr({
            displayName: 'Media',
            type: 'Media',
            group: 'content'
        }),
        imagePosition: setAttr({
            displayName: 'Image position',
            group: 'style',
            defaultValue: 'Normal',
            validations: {
                in: [
                    { value: 'Normal', displayName: 'Top' },
                    { value: 'Right', displayName: 'Right' },
                    { value: 'Bottom', displayName: 'Bottom' },
                    { value: 'LeftEdge', displayName: 'Left' },
                ],
            },
        }),
        imageWidth: setAttr({
            displayName: 'Image width',
            group: 'style',
            type: 'Text',
        }),
        imageHeight: setAttr({
            displayName: 'Image height',
            group: 'style',
            type: 'Text',
        }),
        titleFontSize: setAttr({
            displayName: 'Title Font Size',
            validations: {
                in: [
                    { displayName: "Extra Small", value: "xs" },
                    { displayName: "Small", value: "s" },
                    { displayName: "Medium", value: "m" },
                    { displayName: "Large", value: "l" },
                    { displayName: "Extra Large", value: "xl" },
                ]
            },
            defaultValue: 'm',
        }),
        subtitleFontSize: setAttr({
            displayName: 'Subtitle Font Size',
            validations: {
                in: [
                    { displayName: "Extra Small", value: "xs" },
                    { displayName: "Small", value: "s" },
                    { displayName: "Medium", value: "m" },
                    { displayName: "Large", value: "l" },
                    { displayName: "Extra Large", value: "xl" },
                ]
            },
            defaultValue: 's',
        }),
        bodyFontSize: setAttr({
            displayName: 'Body Font Size',
            validations: {
                in: [
                    { displayName: "Extra Extra Small", value: "xxs" },
                    { displayName: "Extra Small", value: "xs" },
                    { displayName: "Small", value: "s" },
                    { displayName: "Medium", value: "m" },
                    { displayName: "Large", value: "l" },
                    { displayName: "Extra Large", value: "xl" },
                ]
            },
            defaultValue: 'l',
        }),
        title: setAttr({
            displayName: 'Title',
            defaultValue: 'Add your title here',
            group: 'content'
        }),
        subtitle: setAttr({
            displayName: 'Subtitle',
            defaultValue: 'Add your subtitle here',
            group: 'content'
        }),
        description: setAttr({
            displayName: 'Description',
            type: 'RichText',
            group: 'content'
        }),

        // imageBackgroundColor: setAttr({
        //     displayName: 'Image background color',
        //     description:
        //         'Color of the background behind the image. Occurrs when image is positioned beyond the wrapper',
        //     defaultValue: 'transparent',
        //     group: 'style',
        //     type: 'Text',
        // }),

        contentMinHeight: setAttr({
            displayName: 'Content min-height',
            defaultValue: '30px'
        }),
        contentMaxHeight: setAttr({
            displayName: 'Content max-height',
            defaultValue: 'auto'
        }),
        droppableArea: setAttr({
            displayName: 'Droppable area',
            type: 'Boolean',
            defaultValue: false
        }),
        showInSection: setAttr({
            displayName: 'Show In Section',
            group: "style",
            type: 'Boolean',
            defaultValue: false
        }),
        sectionId: setAttr({
            displayName: 'Section Id',
            group: "style",
            type: 'Text'
        })
    },
    "imageCartOptionalParams": {
        cardBackgroundColor: setAttr({
            displayName: 'Background color',
            validations: {
                in: [
                    { displayName: "Transparent", value: "#FFFFFF00" },
                    { displayName: "Yellow", value: "#FFDB00" },
                    { displayName: "Light grey", value: "#D7CFC6" },
                    { displayName: "White", value: "#FFFFFF" },
                    { displayName: "Dark", value: "#1A1A1A" },
                    { displayName: "Light-Brown", value: "#F7F4EF" },
                    { displayName: "Dark-Brown", value: "#EAE3DA" },
                    { displayName: "Blue", value: "#B0D7EC" },
                    { displayName: "Dark-Blue", value: "#0f102a" },
                    { displayName: "Coral-Blue", value: "#B6D9ED" },
                    { displayName: "Grey", value: "#E0E0E0" },
                    { displayName: "Sea-Mist", value: "#C0DDCC" },
                ]
            },
            defaultValue: '#FFFFFF',
        }),
        roundedCorners: setAttr({
            displayName: 'Rounded corners',
            type: 'Boolean',
            group: 'style',
            defaultValue: true
        }),
        centerTextVertically: setAttr({
            displayName: 'Center text vertically',
            type: 'Boolean',
            group: 'style',
            defaultValue: false,
        }),
        imageStartViewX: setAttr({
            displayName: 'Image left offset',
            group: 'style',
            type: 'Text',
        }),
        imageStartViewY: setAttr({
            displayName: 'Image top offset',
            group: 'style',
            type: 'Text',
        }),
        imageWrapperWidth: setAttr({
            displayName: 'Image wrapper width',
            group: 'style',
            type: 'Text',
            defaultValue: '500px',
        }),
        imageWrapperHeight: setAttr({
            displayName: 'Image wrapper height',
            group: 'style',
            type: 'Text',
            defaultValue: '300px',
        }),
        hideButton: setAttr({
            displayName: 'Hide button',
            group: 'style',
            type: 'Boolean',
        }),
        btn1_label: setAttr({
            displayName: 'Button Label',
            defaultValue: 'Submit',
            group: 'content'
        }),
        btn1_icon: setAttr({
            displayName: 'Button Icon',
            defaultValue: 'Placeholder',
            validations: {
                in: [
                    { value: "Placeholder", displayName: "Placeholder" },
                    { value: "Close", displayName: "Close" },
                    { value: "AwardStar", displayName: "AwardStar" },
                    { value: "Clean", displayName: "Clean" },
                    { value: "Error", displayName: "Error" },
                    { value: "FoodTray", displayName: "FoodTray" },
                    { value: "GridDividers", displayName: "GridDividers" },
                    { value: "FurnitureRecycle", displayName: "FurnitureRecycle" },
                    { value: "HandHoldingDollar", displayName: "HandHoldingDollar" },
                    { value: "HandFreeShopping", displayName: "HandFreeShopping" },
                    { value: "HomeDashStar", displayName: "HomeDashStar" },
                    { value: "Facebook", displayName: "Facebook" },
                    { value: "Instagram", displayName: "Instagram" },
                    { value: "Linkedin", displayName: "Linkedin" },
                    { value: "YouTube", displayName: "YouTube" },
                    { value: "Tripadvisor", displayName: "Tripadvisor" },
                    { value: "RecyclingTriangle", displayName: "RecyclingTriangle" },
                    { value: "RecyclingTag", displayName: "RecyclingTag" },
                    { value: "SustainableIdeas", displayName: "SustainableIdeas" },
                    { value: "SustainableChoice", displayName: "SustainableChoice" },
                    { value: "WaterRecycle", displayName: "WaterRecycle" },
                    { value: "Rent", displayName: "Rent" },
                    { value: "Route", displayName: "Route" },
                    { value: "Success", displayName: "Success" },
                    { value: "Warning", displayName: "Warning" },
                    { value: "Security", displayName: "Security" },
                    { value: "SignsDirection", displayName: "SignsDirection" },
                    { value: "Store", displayName: "Store" },
                    { value: "UserStar", displayName: "UserStar" },
                    { value: "UsersGroup", displayName: "UsersGroup" },
                    { value: "Check", displayName: "Check" },
                    { value: "Microphone", displayName: "Microphone" },
                ]
            }
        }),
        btn1_iconPosition: setAttr({
            displayName: 'Icon Position',
            validations: {
                in: [
                    { value: 'hide', displayName: 'None / Hide' },
                    { value: 'top', displayName: 'Top' },
                    { value: 'right', displayName: 'Right' },
                    { value: 'left', displayName: 'Left' },
                ]
            },
            defaultValue: 'hide',
        }),
        btn1_variant: setAttr({
            displayName: 'Button Variant',
            validations: {
                in: [
                    { value: 'primary', displayName: 'Primary' },
                    { value: 'secondary', displayName: 'Secondary' },
                    { value: 'ghost', displayName: 'Ghost' },
                ]
            },
            defaultValue: 'primary',
        }),
        btn1_size: setAttr({
            displayName: 'Button Size',
            validations: {
                in: [
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                ]
            },
            defaultValue: 'm',
        }),
        btn1_action: setAttr({
            displayName: 'Event Name',
            description: 'The event tha should be triggered on click',
        }),
        buttonUrl: setAttr({
            displayName: 'Button URL',
            description: 'Link where clicking the button should direct',
            type: 'Text',
        }),
    },
    "cardImageOverlay": {
        title: setAttr({
            displayName: 'Title',
            defaultValue: 'Add your title here',
            group: 'content'
        }),
        subtitle: setAttr({
            displayName: 'Subtitle',
            defaultValue: 'Add your subtitle here',
            group: 'content'
        }),
        description: setAttr({
            displayName: 'Description',
            type: 'RichText',
            group: 'content'
        }),
        image: setAttr({
            displayName: 'Media',
            type: 'Media',
            group: 'content'
        }),
        overlay1: setAttr({
            displayName: 'Overlay Image 1',
            type: 'Media',
            group: 'content'
        }),
        overlay2: setAttr({
            displayName: 'Overlay Image 2',
            type: 'Media',
            group: 'content'
        }),
        overlay3: setAttr({
            displayName: 'Overlay Image 3',
            type: 'Media',
            group: 'content'
        }),
        btn1_label: setAttr({
            displayName: 'Button Label',
            defaultValue: 'Submit',
            group: 'content'
        }),
        btn1_icon: setAttr({
            displayName: 'Button Icon',
            defaultValue: 'Placeholder',
            validations: {
                in: [
                    { value: "Placeholder", displayName: "Placeholder" },
                    { value: "Close", displayName: "Close" },
                    { value: "AwardStar", displayName: "AwardStar" },
                    { value: "Clean", displayName: "Clean" },
                    { value: "Error", displayName: "Error" },
                    { value: "FoodTray", displayName: "FoodTray" },
                    { value: "GridDividers", displayName: "GridDividers" },
                    { value: "FurnitureRecycle", displayName: "FurnitureRecycle" },
                    { value: "HandHoldingDollar", displayName: "HandHoldingDollar" },
                    { value: "HandFreeShopping", displayName: "HandFreeShopping" },
                    { value: "HomeDashStar", displayName: "HomeDashStar" },
                    { value: "Facebook", displayName: "Facebook" },
                    { value: "Instagram", displayName: "Instagram" },
                    { value: "Linkedin", displayName: "Linkedin" },
                    { value: "YouTube", displayName: "YouTube" },
                    { value: "Tripadvisor", displayName: "Tripadvisor" },
                    { value: "RecyclingTriangle", displayName: "RecyclingTriangle" },
                    { value: "RecyclingTag", displayName: "RecyclingTag" },
                    { value: "SustainableIdeas", displayName: "SustainableIdeas" },
                    { value: "SustainableChoice", displayName: "SustainableChoice" },
                    { value: "WaterRecycle", displayName: "WaterRecycle" },
                    { value: "Rent", displayName: "Rent" },
                    { value: "Route", displayName: "Route" },
                    { value: "Success", displayName: "Success" },
                    { value: "Warning", displayName: "Warning" },
                    { value: "Security", displayName: "Security" },
                    { value: "SignsDirection", displayName: "SignsDirection" },
                    { value: "Store", displayName: "Store" },
                    { value: "UserStar", displayName: "UserStar" },
                    { value: "UsersGroup", displayName: "UsersGroup" },
                    { value: "Check", displayName: "Check" },
                    { value: "Microphone", displayName: "Microphone" },
                ]
            }
        }),
        btn1_iconPosition: setAttr({
            displayName: 'Icon Position',
            validations: {
                in: [
                    { value: 'hide', displayName: 'None / Hide' },
                    { value: 'top', displayName: 'Top' },
                    { value: 'right', displayName: 'Right' },
                    { value: 'left', displayName: 'Left' },
                ]
            },
            defaultValue: 'hide',
        }),
        btn1_variant: setAttr({
            displayName: 'Button Variant',
            validations: {
                in: [
                    { value: 'primary', displayName: 'Primary' },
                    { value: 'secondary', displayName: 'Secondary' },
                    { value: 'ghost', displayName: 'Ghost' },
                ]
            },
            defaultValue: 'primary',
        }),
        btn1_size: setAttr({
            displayName: 'Button Size',
            validations: {
                in: [
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                ]
            },
            defaultValue: 'm',
        }),
        imageWidth: setAttr({
            displayName: 'Image width',
            group: 'style',
            type: 'Text',
        }),
        imageHeight: setAttr({
            displayName: 'Image height',
            group: 'style',
            type: 'Text',
        }),
        imageWrapperWidth: setAttr({
            displayName: 'Image wrapper width',
            group: 'style',
            type: 'Text',
            defaultValue: '500px',
        }),
        imageWrapperHeight: setAttr({
            displayName: 'Image wrapper height',
            group: 'style',
            type: 'Text',
            defaultValue: '300px',
        }),
    },
    "landing": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        heading: setAttr({
            displayName: 'Heading',
            defaultValue: 'Heading ...',
            group: 'content'
        }),
        video: setAttr({
            displayName: 'Desktop Video',
            type: 'Media',
            group: 'content'
        }),
        minHeight: setAttr({
            displayName: 'Minimun video height',
            defaultValue: '100px',
        }),
        mobileVideo: setAttr({
            displayName: 'Mobile Video',
            type: 'Media',
            group: 'content'
        }),
        image: setAttr({
            displayName: 'Placeholder image',
            type: 'Media',
            group: 'content',
        }),
        mobileImage: setAttr({
            displayName: 'Mobile placeholder image',
            type: 'Media',
            group: 'content',
        }),
        mute: setAttr({
            displayName: 'Muted',
            type: 'Boolean',
            defaultValue: true,
        }),
        blurOnLoad: setAttr({
            displayName: 'Show blurred image on load',
            type: 'Boolean',
            defaultValue: false,
        }),
        restrictHeight: setAttr({
            displayName: 'Restrict height to 100vh',
            type: 'Boolean',
            defaultValue: true,
        })
    },
    "landingImage": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        heading: setAttr({
            displayName: 'Heading',
            defaultValue: 'Heading ...',
            group: 'content'
        }),
        image: setAttr({
            displayName: 'Image',
            type: 'Media',
            group: 'content'
        }),
    },
    "quoteVideo": {
        author: setAttr({
            displayName: 'Author',
            defaultValue: 'Add author here',
            group: 'content'
        }),
        description: setAttr({
            displayName: 'Description',
            type: 'RichText',
            group: 'content'
        }),
        jobPosition: setAttr({
            displayName: 'Job position',
            group: 'content'
        }),
        image: setAttr({
            displayName: 'Image',
            group: 'content',
            type: 'Media',
        }),
    },
    "carouselContainer": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        title: setAttr({
            displayName: 'Title',
            group: 'content'
        }),
        description: setAttr({
            displayName: 'Description',
            group: 'content'
        }),
        // autoscroll: setAttr({
        //     displayName: 'Autoscroll',
        //     type: 'Boolean',
        //     defaultValue: false,
        // }),
        autoplay: setAttr({
            displayName: 'Autoplay',
            type: 'Boolean',
            defaultValue: false,
        }),
        showButtons: setAttr({
            displayName: 'Show Nav Buttons',
            type: 'Boolean',
            defaultValue: false,
        }),
        showPaging: setAttr({
            displayName: 'Show Pagination',
            type: 'Boolean',
            defaultValue: false,
        }),
        infinite: setAttr({
            displayName: 'Infinite',
            type: 'Boolean',
            defaultValue: false,
        }),
        pauseOnHover: setAttr({
            displayName: 'Pause on hover',
            type: 'Boolean',
            defaultValue: false,
        }),
        swipeToSlide: setAttr({
            displayName: 'Swipe To Slide',
            type: 'Boolean',
            defaultValue: false,
        }),
        draggable: setAttr({
            displayName: 'Draggable',
            type: 'Boolean',
            defaultValue: false,
        }),
        variableWidth: setAttr({
            displayName: 'Variable Width',
            type: 'Boolean',
            defaultValue: true,
        }),
        slidesToShow: setAttr({
            displayName: 'Slides To Show',
            group: 'style',
            type: 'Number',
            defaultValue: 3,
        }),
        slidesToScroll: setAttr({
            displayName: 'Slides To Scroll',
            group: 'style',
            type: 'Number',
            defaultValue: 1,
        }),
        autoplaySpeed: setAttr({
            displayName: 'Autoplay Speed',
            group: 'style',
            type: 'Number',
            defaultValue: 2000,
        }),
        speed: setAttr({
            displayName: 'Speed',
            group: 'style',
            type: 'Number',
            defaultValue: 1000,
        }),
        animationType: setAttr({
            displayName: "Animation type",
            type: 'Text',
            defaultValue: "ease-in-out",
            group: 'style',
            validations: {
                in: [
                    { value: 'ease', displayName: 'Ease' },
                    { value: 'ease-in', displayName: 'Ease in' },
                    { value: 'ease-out', displayName: 'Ease out' },
                    { value: 'ease-in-out', displayName: 'Ease in out' },
                    { value: 'linear', displayName: 'Linear' },
                ]
            }
        }),
        transitionType: setAttr({
            displayName: "Transition type",
            type: 'Text',
            defaultValue: "none",
            group: 'style',
            validations: {
                in: [
                    { value: 'none', displayName: 'None' },
                    { value: 'fade', displayName: 'Fade' },
                ]
            }
        }),
        // centerMode: setAttr({
        //     displayName: 'Center Mode',
        //     type: 'Boolean',
        //     defaultValue: false,
        // }),
    },
    "scrollableContainer": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        title: setAttr({
            displayName: "Title",
            group: 'content'
        }),
        description: setAttr({
            displayName: "Description",
            type: "RichText",
            group: 'content'
        }),
        image: setAttr({
            displayName: "Image",
            type: "Media",
            group: 'content'
        }),
    },
    "buttonProps": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        value: setAttr({
            displayName: 'Text',
            defaultValue: 'Add your text here',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Type',
            validations: {
                in: [
                    { value: 'button', displayName: 'Button' },
                    { value: 'submit', displayName: 'Submit' },
                    { value: 'reset', displayName: 'Reset' }
                ]
            },
            defaultValue: 'button',
        }),
        variant: setAttr({
            displayName: 'Variant',
            validations: {
                in: [
                    { value: 'primary', displayName: 'Primary' },
                    { value: 'secondary', displayName: 'Secondary' },
                    { value: 'ghost', displayName: 'Ghost' },
                    { value: 'link', displayName: 'Link' },
                ]
            },
            defaultValue: 'primary',
        }),
        size: setAttr({
            displayName: 'Size',
            validations: {
                in: [
                    { value: 'z', displayName: 'Zero Padding' },
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' },
                ]
            },
            defaultValue: 'm',
        }),
        fullWidth: setAttr({
            displayName: 'Full width',
            type: 'Boolean',
            defaultValue: true,
            description: 'Button full width'
        }),
        eventName: setAttr({
            displayName: 'Event name',
            description: 'The event the should be triggered on click',
        }),
        hide: setAttr({
            displayName: "Hide",
            type: "Boolean",
            description: "Select if element needs to be hidden.",
            group: 'style',
            defaultValue: false
        }),
        cssClass: setAttr({
            displayName: 'Css Class',
            description: 'The css class',
            group: 'content'
        }),
        GTMLabel: setAttr({
            displayName: 'GTM label',
            defaultValue: "",
            group: "content",
        }),
        GTMEnabled: setAttr({
            displayName: "Enable GTM",
            type: "Boolean",
            description: "Enable GTM data push on button click",
            group: 'style',
            defaultValue: false
        }),
        GTMEvent: setAttr({
            displayName: 'Event',
            description: 'Button events',
            group: 'style',
            validations: {
                in: [
                    { value: 'click', displayName: 'Click' },
                    { value: 'reset', displayName: 'Reset' },
                    { value: 'submit', displayName: 'Submit' }
                ]
            },
            defaultValue: 'click',
        }),
        intent: setAttr({
            displayName: 'GTM intent(facebook|instagram|etc.)',
            defaultValue: "",
            group: 'style',
            validations: {
                in: [
                    { value: '', displayName: 'Select' },
                    { value: 'Facebook', displayName: 'Facebook' },
                    { value: 'Instagram', displayName: 'Instagram' },
                    { value: 'TikTok', displayName: 'TikTok' },
                    { value: 'YouTube', displayName: 'YouTube' },
                    { value: 'Whatsapp', displayName: 'Whatsapp' },
                    { value: 'MeetingPlace', displayName: 'MeetingPlace' },
                    { value: 'IKEA', displayName: 'Ikea' },
                    { value: 'BookingEngine', displayName: 'BookingEngine' },
                    { value: 'Quiz', displayName: 'Quiz' },
                    { value: 'Offer', displayName: 'Offer' },
                    { value: 'Others', displayName: 'Others' }
                ]
            },
        })
    },
    "buttonWrapper": {
        url: setAttr({
            displayName: 'URL',
            defaultValue: '/',
            group: 'content'
        }),
        targetBlank: setAttr({
            displayName: 'Open in new tab',
            type: 'Boolean',
            defaultValue: false
        }),
        type: setAttr({
            displayName: 'Type',
            validations: {
                in: [
                    { value: 'button', displayName: 'Button' },
                    { value: 'submit', displayName: 'Submit' },
                    { value: 'reset', displayName: 'Reset' },
                    { value: 'link', displayName: 'Link' }
                ]
            },
            defaultValue: 'button',
        }),
        showInSection: setAttr({
            displayName: 'Show In Section',
            group: "style",
            type: 'Boolean',
            defaultValue: false
        }),
        sectionId: setAttr({
            displayName: 'Section Id',
            group: "style",
            type: 'Text'
        })
    },
    "link2": {
        url: setAttr({
            displayName: 'URL',
            defaultValue: '#',
            group: 'content'
        }),
        type: setAttr({
            displayName: 'Type',
            validations: {
                in: [
                    { value: 'link', displayName: 'Link' }
                ]
            },
            defaultValue: 'link',
        }),
        targetBlank: setAttr({
            displayName: 'Open in new tab',
            validations: {
                in: [
                    { value: 'false', displayName: 'False' },
                    { value: 'true', displayName: 'True' }
                ]
            },
            defaultValue: 'false',
        }),
        reload: setAttr({
            displayName: 'Reload in same tab',
            type: 'Boolean',
            defaultValue: false
        })
    },
    "formButton": {
        type: setAttr({
            displayName: 'Type',
            validations: {
                in: [
                    { value: 'button', displayName: 'Button' },
                    { value: 'submit', displayName: 'Submit' },
                    { value: 'reset', displayName: 'Reset' },
                    { value: 'link', displayName: 'Link' }
                ]
            },
            defaultValue: 'submit',
        })
    },
    "sectionAnchorId": {
        anchorId: setAttr({
            displayName: '#ID',
            group: 'content'
        })
    },
    "body": {
        description: setAttr({
            displayName: 'Text',
            type: 'RichText',
            group: 'content',
            defaultValue: {
                nodeType: 'document',
                data: {},
                content: [
                    {
                        nodeType: 'paragraph',
                        content: [
                            {
                                nodeType: 'text',
                                value: '',
                                marks: [],
                                data: {}
                            }
                        ],
                        data: {}
                    }
                ]
            }
        }),
        size: setAttr({
            displayName: 'Size',
            defaultValue: 'm',
            validations: {
                in: [
                    { value: 'xxs', displayName: 'XX Small' },
                    { value: 'xs', displayName: 'Extra Small' },
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' }
                ]
            }
        }),
        fontStyle: setAttr({
            displayName: 'Font Family',
            defaultValue: 'default',
            validations: {
                in: [
                    { value: 'default', displayName: 'Default' },
                    { value: 'livelyHeadline', displayName: 'Lively Headline' },
                    { value: 'notoIkea', displayName: 'Noto Ikea' },
                    { value: 'micro', displayName: 'Micro 5' },
                ]
            }
        }),
        hide: setAttr({
            displayName: "Hide",
            type: "Boolean",
            description: "Select if element needs to be hidden.",
            group: 'style',
            defaultValue: false
        }),
        linksInNewTab: setAttr({
            displayName: "Open Links in new tab",
            type: "Boolean",
            description: "Select if links in text need to open in new tab.",
            group: 'style',
            defaultValue: true
        })
    },
    "display": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        text: setAttr({
            displayName: 'Text',
            defaultValue: 'Add your text here',
            group: 'content'
        }),
        size: setAttr({
            displayName: 'Size',
            defaultValue: 'm',
            validations: {
                in: [
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' }
                ]
            }
        }),
        fontStyle: setAttr({
            displayName: 'Font Family',
            defaultValue: 'default',
            validations: {
                in: [
                    { value: 'default', displayName: 'Default' },
                    { value: 'livelyHeadline', displayName: 'Lively Headline' },
                    { value: 'notoIkea', displayName: 'Noto Ikea' },
                    { value: 'micro', displayName: 'Micro 5' },
                ]
            }
        }),
        hide: setAttr({
            displayName: "Hide",
            type: "Boolean",
            description: "Select if element needs to be hidden.",
            group: 'style',
            defaultValue: false
        }),
    },
    "heading": {
        id: setAttr({
            displayName: 'ID',
            group: 'content'
        }),
        text: setAttr({
            displayName: 'Text',
            defaultValue: 'Add your text here',
            group: 'content'
        }),
        variant: setAttr({
            displayName: 'VariantMain',
            defaultValue: 'h2',
            validations: {
                in: [
                    { value: 'h1', displayName: 'H1' },
                    { value: 'h2', displayName: 'H2' },
                    { value: 'h3', displayName: 'H3' },
                ]
            },
        }),
        size: setAttr({
            displayName: 'Size',
            defaultValue: 'm',
            validations: {
                in: [
                    { value: 'xs', displayName: 'Extra Small' },
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' }
                ]
            }
        }),
        fontStyle: setAttr({
            displayName: 'Font Family',
            defaultValue: 'default',
            validations: {
                in: [
                    { value: 'default', displayName: 'Default' },
                    { value: 'livelyHeadline', displayName: 'Lively Headline' },
                    { value: 'notoIkea', displayName: 'Noto Ikea' },
                    { value: 'micro', displayName: 'Micro 5' },
                ]
            }
        }),
        hide: setAttr({
            displayName: "Hide",
            type: "Boolean",
            description: "Select if element needs to be hidden.",
            group: 'style',
            defaultValue: false
        })
    },
    "icons": {
        size: setAttr({
            displayName: 'Size',
            defaultValue: 'm',
            validations: {
                in: [
                    { value: 's', displayName: 'Small' },
                    { value: 'm', displayName: 'Medium' },
                    { value: 'l', displayName: 'Large' },
                    { value: 'xl', displayName: 'Extra Large' },
                    { value: 'xxl', displayName: 'XX Large' },
                    { value: 'xxxl', displayName: 'XXX Large' },
                    { value: 'full', displayName: 'Full' },
                    { value: 'big', displayName: 'Big' },
                ]
            }
        }),
        iconName: setAttr({
            displayName: 'Icon',
            defaultValue: 'Placeholder',
            validations: {
                in: [
                    { value: "Placeholder", displayName: "Placeholder" },
                    { value: "Close", displayName: "Close" },
                    { value: "AwardStar", displayName: "AwardStar" },
                    { value: "Clean", displayName: "Clean" },
                    { value: "Error", displayName: "Error" },
                    { value: "FoodTray", displayName: "FoodTray" },
                    { value: "GridDividers", displayName: "GridDividers" },
                    { value: "FurnitureRecycle", displayName: "FurnitureRecycle" },
                    { value: "HandHoldingDollar", displayName: "HandHoldingDollar" },
                    { value: "HandFreeShopping", displayName: "HandFreeShopping" },
                    { value: "HomeDashStar", displayName: "HomeDashStar" },
                    { value: "Facebook", displayName: "Facebook" },
                    { value: "Instagram", displayName: "Instagram" },
                    { value: "Linkedin", displayName: "Linkedin" },
                    { value: "YouTube", displayName: "YouTube" },
                    { value: "Tripadvisor", displayName: "Tripadvisor" },
                    { value: "RecyclingTriangle", displayName: "RecyclingTriangle" },
                    { value: "RecyclingTag", displayName: "RecyclingTag" },
                    { value: "SustainableIdeas", displayName: "SustainableIdeas" },
                    { value: "SustainableChoice", displayName: "SustainableChoice" },
                    { value: "WaterRecycle", displayName: "WaterRecycle" },
                    { value: "Rent", displayName: "Rent" },
                    { value: "Route", displayName: "Route" },
                    { value: "Success", displayName: "Success" },
                    { value: "Warning", displayName: "Warning" },
                    { value: "Security", displayName: "Security" },
                    { value: "SignsDirection", displayName: "SignsDirection" },
                    { value: "Store", displayName: "Store" },
                    { value: "UserStar", displayName: "UserStar" },
                    { value: "UsersGroup", displayName: "UsersGroup" },
                    { value: "Check", displayName: "Check" },
                    { value: "Microphone", displayName: "Microphone" },
                    { value: "ShoppingCart", displayName: "Shopping Cart" },
                    { value: "User", displayName: "User" },
                    { value: "World", displayName: "World" },
                ]
            }
        }),
    },
    "marquee": {
        text: setAttr({
            displayName: 'Text',
            defaultValue: 'Add your text here',
            group: 'content'
        })
    },
    "footerContainer": {
        image: setAttr({
            displayName: 'Footer Logo',
            type: 'Media',
            group: 'content'
        }),
        copyrightText: setAttr({
            displayName: 'Copyright text',
            type: 'RichText',
            group: 'content'
        }),
        privacyLabel: setAttr({
            displayName: 'Privacy label',
            group: 'content'
        }),
        privacyUrl: setAttr({
            displayName: 'Privacy url',
            group: 'content'
        }),
        cookieSettingsLabel: setAttr({
            displayName: 'Coockie Settings label',
            group: 'content'
        }),
        cookiePrivacyPolicyUrl: setAttr({
            displayName: 'Cookie Privacy policy url',
            group: 'content'
        }),
        cookiePrivacyPolicyLabel: setAttr({
            displayName: 'Cookie Privacy policy label',
            group: 'content'
        }),
    },
    "contactUs": {
        forwardingEmailSubject: setAttr({
            displayName: 'Forward Email Subject',
            description: 'The Subject used for the forward email',
            group: 'content'
        }),
        responseEmailSubject: setAttr({
            displayName: 'Response Email Subject',
            description: 'The Subject used for the response email to the user',
            group: 'content'
        }),
        responseEmailTemplate: setAttr({
            displayName: 'Response Email Template',
            description: 'The Template used for the email to the user',
            type: 'RichText',
            group: 'content'
        }),
        forwardingEmailTemplate: setAttr({
            displayName: 'Forward Email Template',
            description: 'The Template used for the email forwarded to Ingka',
            type: 'RichText',
            group: 'content'
        }),
        nameFieldLabel: setAttr({
            displayName: 'Name field label',
            description: 'The label for NAME input',
            group: 'content'
        }),
        emailFieldLabel: setAttr({
            displayName: 'Email field label',
            description: 'The label for EMAIL input',
            group: 'content'
        }),
        confirmEmailFieldLabel: setAttr({
            displayName: 'Confirm Email field label',
            description: 'The label for CONFIRM EMAIL input',
            group: 'content'
        }),
        companyFieldLabel: setAttr({
            displayName: 'Company field label',
            description: 'The label for COMPANY input',
            group: 'content'
        }),
        locationsFieldLabel: setAttr({
            displayName: 'Locations field label',
            description: 'The label for LOCATIONS input',
            group: 'content'
        }),
        dateFieldLabel: setAttr({
            displayName: 'Meeting date field label',
            description: 'The label for MEETING DATE input',
            group: 'content'
        }),
        messageFieldLabel: setAttr({
            displayName: 'Message date field label',
            description: 'The label for MESSAGE DATE input',
            group: 'content'
        }),
        submitLabel: setAttr({
            displayName: 'Submit button label',
            description: 'The label for SUBMIT DATE input',
            group: 'content'
        }),
        privacyMessage: setAttr({
            displayName: 'Form privacy message',
            description: 'The privacy message of the form',
            group: 'content'
        }),
        privacyLinkLabel: setAttr({
            displayName: 'Form privacy Link label',
            description: 'The privacy label of the form',
            group: 'content'
        }),
        privacyLinkUrl: setAttr({
            displayName: 'Form privacy link url',
            description: 'The privacy url of the form',
            group: 'content'
        }),
        captchaMessage: setAttr({
            displayName: 'Form captcha message',
            description: 'The captcha message of the form',
            group: 'content'
        }),
        thankYouMessage: setAttr({
            displayName: 'Form success message',
            description: 'The success message of the form',
            group: 'content'
        }),
        errorMessage: setAttr({
            displayName: 'Error message',
            description: 'The error message if form is not submitted',
            group: 'content'
        }),
        topImage: setAttr({
            displayName: 'Top Image',
            type: 'Media',
            group: 'content'
        }),
        bottomImage: setAttr({
            displayName: 'Bottom Image',
            type: 'Media',
            group: 'content'
        }),
        enableDatePicker: setAttr({
            displayName: 'Enable date picker',
            description: 'Enable the field that permits to choose a meeting date',
            type: 'Boolean',
            defaultValue: false,
        }),
        enableLocationByPreference: setAttr({
            displayName: 'Enable location by preference',
            type: 'Boolean',
            defaultValue: false,
        }),
        inModal: setAttr({
            displayName: 'Form is in modal',
            description: 'Form is displayed inside modal',
            type: 'Boolean',
            defaultValue: false,
        }),
        emailRecepients: setAttr({
            displayName: 'Email recepients',
            type: 'Text',
            description: 'The email address of the recepient',
            group: 'content'
        }),
    },
    "counter": {
        labels: setAttr({
            displayName: 'Labels',
            description: 'Labels are used for counter text',
            defaultValue: 'Days,Hours,Minutes,Seconds',
            group: 'content'
        }),
        hide: setAttr({
            displayName: "Hide",
            type: "Boolean",
            description: "Select if element needs to be hidden.",
            group: 'style',
            defaultValue: false
        }),
        // days: setAttr({
        //     displayName: 'Days',
        //     description: 'This is used to provides the day count input',
        //     group: 'content',
        //     type: 'Number'
        // }),
        // hours: setAttr({
        //     displayName: 'Hours',
        //     description: 'This is used to provides the hour count input',
        //     group: 'content',
        //     type: 'Number'
        // }),
        // minutes: setAttr({
        //     displayName: 'Minutes',
        //     description: 'This is used to provides the minute count input',
        //     group: 'content',
        //     type: 'Number'
        // }),
        // seconds: setAttr({
        //     displayName: 'Seconds',
        //     description: 'This is used to provides the second count input',
        //     group: 'content',
        //     type: 'Number'
        // }),
        size: setAttr({
            displayName: 'Size',
            description: 'Change the font size and box soze of every digit',
            defaultValue: 'text-counter-l',
            validations: {
                in: [
                    { value: 'text-counter-s', displayName: 'Small' },
                    { value: 'text-counter-m', displayName: 'Medium' },
                    { value: 'text-counter-l', displayName: 'Large' },
                    { value: 'text-counter-xl', displayName: 'Extra Large' },
                ]
            },
        }),
        variant: setAttr({
            displayName: 'Variant',
            description: 'Select a variant',
            defaultValue: 'text-counter-fg-default',
            validations: {
                in: [
                    { value: 'text-counter-fg-default', displayName: 'Default' },
                    // { value: 'text-counter-fg-primary', displayName: 'Primary' },
                    // { value: 'text-counter-fg-secondary', displayName: 'Secondary' },
                    { value: 'text-counter-fg-dark', displayName: 'Dark' }
                ]
            },
        }),
        startDate: setAttr({
            displayName: 'Start date',
            description: 'Start date is used to enable this counter till targated date',
            group: 'content',
            // defaultValue: (()=>{
            //     const dt = new Date();
            //     dt.setDate(dt.getDate() + 7)
            //     return dt.toLocaleDateString();
            // })()
            // type: 'Date'
        }),
        targetDate: setAttr({
            displayName: 'Target date',
            description: 'This is used to provides the date input',
            group: 'content',
            // defaultValue: (()=>{
            //     const dt = new Date();
            //     dt.setDate(dt.getDate() + 7)
            //     return dt.toLocaleDateString();
            // })()
            // type: 'Date'
        }),
        datesJson: setAttr({
            displayName: 'Multiple dates',
            description: 'Multiple dates to enable and disable same counter multiple times',
            group: 'content',
            // defaultValue: '[{"startDate": "some value", "targetDate": "some value"}]'
            // defaultValue: (()=>{
            //     const dt = new Date();
            //     dt.setDate(dt.getDate() + 7)
            //     return [{"startDate": new Date(), "targetDate": dt.toLocaleDateString()}];
            // })(),
            // type: 'Object'
        }),
    },
    "themeSelector": {
        selectedTheme: setAttr({
            displayName: 'Select theme',
            description: 'Initiative theme',
            defaultValue: 'custom',
            validations: {
                in: [
                    { value: 'custom', displayName: 'Baseplate' },
                    { value: 'circuit', displayName: 'Circuit' },
                    { value: 'livat', displayName: 'Livat' },
                    { value: 'futures', displayName: 'Futures' },
                    { value: 'esports', displayName: 'Esports' },
                    { value: 'livealmhult', displayName: 'Live! Almhult' }
                ]
            },
        }),
    },
    "stickyElement": {
        top: setAttr({
            displayName: 'Top',
            description: 'Top position of the sticky element',
            group: 'style',
            type: 'Text',
            defaultValue: '0',
        }),
        right: setAttr({
            displayName: 'Right',
            description: 'Right position of the sticky element',
            group: 'style',
            type: 'Text',
            defaultValue: '0',
        }),
        bottom: setAttr({
            displayName: 'Bottom',
            description: 'Bottom position of the sticky element',
            group: 'style',
            type: 'Text',
            defaultValue: '0',
        }),
        left: setAttr({
            displayName: 'Left',
            description: 'Left position of the sticky element',
            group: 'style',
            type: 'Text',
            defaultValue: '0',
        }),
    },
    "productFeed": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        rating_value: setAttr({
            type: "Number",
            defaultValue: 1,
            displayName: "Rating Value",
            group: "style"
        }),
        breathtakingitem: setAttr({
            type: "Boolean",
            defaultValue: false,
            displayName: "Breathtaking Item",
            group: "style"
        }),
        isNew: setAttr({
            type: "Boolean",
            defaultValue: true,
            displayName: "Is New",
            group: "style"
        }),
        isTopSeller: setAttr({
            type: "Boolean",
            defaultValue: true,
            displayName: "Is Top seller",
            group: "style"
        }),
        isLastChance: setAttr({
            type: "Boolean",
            defaultValue: false,
            displayName: "Is Last Chancer",
            group: "style"
        }),
        newLowerPrice: setAttr({
            type: "Boolean",
            defaultValue: true,
            displayName: "New Lower Price",
            group: "style"
        }),
        isLimitEdition: setAttr({
            type: "Boolean",
            defaultValue: true,
            displayName: "Is Limit Edition",
            group: "style"
        }),
        timeRestrictedOffer: setAttr({
            type: "Boolean",
            defaultValue: false,
            displayName: "Timie Restricted Offer",
            group: "style"
        }),
        numberOfItem: setAttr({
            type: "Number",
            defaultValue: 5,
            displayName: "No. of Items",
            group: "style"
        }),
        enablePaxItems: setAttr({
            type: "Boolean",
            defaultValue: false,
            displayName: "Pax Items",
            group: "style"
        }),
        marketLocale: setAttr({
            type: "Text",
            defaultValue: "",
            displayName: "Market Locale",
            group: "content"
        }),
        btnLabel: setAttr({
            type: "Text",
            defaultValue: "",
            displayName: "Button Label",
            group: "content"
        }),
        businessUnitCode: setAttr({
            type: "Text",
            defaultValue: "SHC059",
            displayName: "Meeting Place Code",
            group: "content"
        }),
        no_of_columns: setAttr({
            type: "Number",
            defaultValue: 2,
            displayName: "No. of Columns",
            group: "style",
            validations: {
                in: [
                    { value: 1, displayName: '1' },
                    { value: 2, displayName: '2' },
                    { value: 3, displayName: '3' },
                    { value: 4, displayName: '4' },
                    { value: 5, displayName: '5' },
                    { value: 6, displayName: '6' },
                ]
            },
        }),
        displayView: setAttr({
            type: "Text",
            defaultValue: "grid",
            displayName: "Display",
            group: "style",
            validations: {
                in: [
                    { value: "grid", displayName: 'Grid' },
                    { value: "carousel", displayName: 'Carousel' },
                ]
            },
        }),

        // carousel settings
        carouselAutoplay: setAttr({
            displayName: 'Autoplay',
            type: 'Boolean',
            defaultValue: false,
        }),
        showButtons: setAttr({
            displayName: 'Show Nav Buttons',
            type: 'Boolean',
            defaultValue: false,
        }),
        showPaging: setAttr({
            displayName: 'Show Pagination',
            type: 'Boolean',
            defaultValue: false,
        }),
        infinite: setAttr({
            displayName: 'Infinite',
            type: 'Boolean',
            defaultValue: false,
        }),
        pauseOnHover: setAttr({
            displayName: 'Pause on hover',
            type: 'Boolean',
            defaultValue: false,
        }),
        swipeToSlide: setAttr({
            displayName: 'Swipe To Slide',
            type: 'Boolean',
            defaultValue: false,
        }),
        draggable: setAttr({
            displayName: 'Draggable',
            type: 'Boolean',
            defaultValue: false,
        }),
        variableWidth: setAttr({
            displayName: 'Variable Width',
            type: 'Boolean',
            defaultValue: false,
        }),
        slidesToShow: setAttr({
            displayName: 'Slides To Show',
            group: 'style',
            type: 'Number',
            defaultValue: 3,
        }),
        slidesToScroll: setAttr({
            displayName: 'Slides To Scroll',
            group: 'style',
            type: 'Number',
            defaultValue: 1,
        }),
        autoplaySpeed: setAttr({
            displayName: 'Autoplay Speed',
            group: 'style',
            type: 'Number',
            defaultValue: 2000,
        }),
        speed: setAttr({
            displayName: 'Speed',
            group: 'style',
            type: 'Number',
            defaultValue: 1000,
        }),
        // arrayList: setAttr({
        //     type: "Link",
        //     displayName: 'Meeting Place List',
        //     group: 'content'
        // }),
        // domain: setAttr({
        //     type: "Text",
        //     displayName: "Meeting Place URL",
        //     group: "content"
        // }),
        maxCardWidth: setAttr({
            displayName: 'Card Max Width (px)',
            group: 'style',
            type: 'Number',
            defaultValue: 350,
        }),
        carouseltransition: setAttr({
            displayName: "Transition type",
            type: 'Text',
            defaultValue: "none",
            group: 'style',
            validations: {
                in: [
                    { value: 'none', displayName: 'None' },
                    { value: 'fade', displayName: 'Fade' },
                ]
            }
        }),
    },
    "generalListingComp": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        displayView: setAttr({
            type: "Text",
            defaultValue: "grid",
            displayName: "Display",
            group: "style",
            validations: {
                in: [
                    { value: "grid", displayName: 'Grid' },
                    { value: "carousel", displayName: 'Carousel' },
                ]
            },
        }),
        carouselAutoplay: setAttr({
            displayName: 'Autoplay',
            type: 'Boolean',
            defaultValue: false,
        }),
        showButtons: setAttr({
            displayName: 'Show Nav Buttons',
            type: 'Boolean',
            defaultValue: false,
        }),
        showPaging: setAttr({
            displayName: 'Show Pagination',
            type: 'Boolean',
            defaultValue: false,
        }),
        infinite: setAttr({
            displayName: 'Infinite',
            type: 'Boolean',
            defaultValue: false,
        }),
        pauseOnHover: setAttr({
            displayName: 'Pause on hover',
            type: 'Boolean',
            defaultValue: false,
        }),
        swipeToSlide: setAttr({
            displayName: 'Swipe To Slide',
            type: 'Boolean',
            defaultValue: false,
        }),
        draggable: setAttr({
            displayName: 'Draggable',
            type: 'Boolean',
            defaultValue: false,
        }),
        variableWidth: setAttr({
            displayName: 'Variable Width',
            type: 'Boolean',
            defaultValue: false,
        }),
        slidesToShow: setAttr({
            displayName: 'Slides To Show',
            group: 'style',
            type: 'Number',
            defaultValue: 3,
        }),
        slidesToScroll: setAttr({
            displayName: 'Slides To Scroll',
            group: 'style',
            type: 'Number',
            defaultValue: 1,
        }),
        autoplaySpeed: setAttr({
            displayName: 'Autoplay Speed',
            group: 'style',
            type: 'Number',
            defaultValue: 2000,
        }),
        speed: setAttr({
            displayName: 'Speed',
            group: 'style',
            type: 'Number',
            defaultValue: 1000,
        }),
        arrayList: setAttr({
            type: "Link",
            displayName: 'Meeting Place List',
            group: 'content'
        }),
        slugList: setAttr({
            type: "Text",
            displayName: 'Offer Filter List',
            defaultValue: "",
            group: 'content'
        }),
        domain: setAttr({
            type: "Text",
            displayName: "Meeting Place URL",
            group: "content"
        }),
        datePrefix: setAttr({
            type: "Text",
            displayName: "Date Prefix",
            defaultValue: "Valid until",
            group: "content"
        }),
        buttonText: setAttr({
            type: "Text",
            defaultValue: "View offer",
            displayName: "Button Text",
            group: "content"
        }),
        maxCardWidth: setAttr({
            displayName: 'Card Max Width (px)',
            group: 'style',
            type: 'Number',
            defaultValue: 350,
        }),
        // animationType: setAttr({
        //     displayName: "Animation type",
        //     type: 'Text',
        //     defaultValue: "ease-in-out",
        //     group: 'style',
        //     validations: {
        //         in: [
        //             {value: 'ease', displayName: 'Ease'},
        //             {value: 'ease-in', displayName: 'Ease in'},
        //             {value: 'ease-out', displayName: 'Ease out'},
        //             {value: 'ease-in-out', displayName: 'Ease in out'},
        //             {value: 'linear', displayName: 'Linear'},
        //         ]
        //     }
        // }),
        no_of_columns: setAttr({
            type: "Number",
            defaultValue: 2,
            displayName: "No. of Columns",
            group: "style",
            validations: {
                in: [
                    { value: 1, displayName: '1' },
                    { value: 2, displayName: '2' },
                    { value: 3, displayName: '3' },
                    { value: 4, displayName: '4' },
                    { value: 5, displayName: '5' },
                    { value: 6, displayName: '6' },
                ]
            },
        }),
        carouseltransition: setAttr({
            displayName: "Transition type",
            type: 'Text',
            defaultValue: "none",
            group: 'style',
            validations: {
                in: [
                    { value: 'none', displayName: 'None' },
                    { value: 'fade', displayName: 'Fade' },
                ]
            }
        }),
    },
    "embeddedContainer": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        src: setAttr({
            displayName: 'Image source',
            type: 'Media',
            group: 'content',
            validations: {
                required: true,
                pattern: '^https?://.*\\.(jpg|jpeg|png|webp|gif|svg)$'
            }
        }),
        damSrc: setAttr({
            displayName: 'DAM Image source',
            type: 'Object',
            group: 'content'
        }),
        damThumbnail: setAttr({
            displayName: 'DAM Thumbnail source',
            type: 'Object',
            group: 'content'
        }),
        embedCode: setAttr({
            type: "Text",
            displayName: 'Embed Code',
            group: 'content'
        })
    },
    "bookingConfirmationPanel": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        autoConfirmModalFormEvent: setAttr({
            type: "Text",
            displayName: 'Auto-confirm Modal Event',
            group: 'style'
        }),
        autoConfirmModalId: setAttr({
            type: "Text",
            displayName: 'Auto-confirm modal Id',
            group: 'style'
        }),
        autoConfirmSubmitButtonId: setAttr({
            type: "Text",
            displayName: 'Auto-confirm Submit Button Id',
            group: 'style'
        }),
        autoConfirmFormId: setAttr({
            type: "Text",
            displayName: 'Auto-confirm Form Id',
            group: 'style'
        }),
        triggerFlowKey: setAttr({
            type: "Text",
            displayName: 'Cookie Key',
            group: 'style'
        }),
        // hiddenInputName: setAttr({
        //     type: "Text",
        //     displayName: 'Auto-confirm Hidden Input Name',
        //     group: 'style'
        // }),
        signupConfirmModalEvent: setAttr({
            type: "Text",
            displayName: 'Signup and Confirm Modal Event',
            group: 'style'
        }),
        signupConfirmModalId: setAttr({
            type: "Text",
            displayName: 'Signup and Confirm Modal Id',
            group: 'style'
        }),
        // signupConfirmModalEvent: setAttr({
        //     type: "Text",
        //     displayName: 'Signup confirmation Modal event name',
        //     group: 'style'
        // })
    },
    "productCard": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        brand: setAttr({
            type: "Text",
            displayName: 'Brand',
            defaultValue: "Brand",
            group: 'content'
        }),
        title: setAttr({
            type: "Text",
            displayName: 'Product Title',
            defaultValue: "Prod title",
            group: 'content'
        }),
        subTitle: setAttr({
            type: "Text",
            displayName: 'Product description',
            defaultValue: "Prod desc",
            group: 'content'
        }),
        price: setAttr({
            type: "Text",
            displayName: 'Price',
            defaultValue: "$45",
            group: 'content'
        }),
        image_link: setAttr({
            type: "Media",
            displayName: 'Image',
            group: 'content'
        }),
        buttonLabel: setAttr({
            type: "Text",
            defaultValue: "Buy now",
            displayName: "Button label",
            group: "content"
        }),
        businessUnitCode: setAttr({
            type: "Text",
            defaultValue: "SHC059",
            displayName: "Meeting Place Code",
            group: "content"
        }),
        link: setAttr({
            type: "Text",
            defaultValue: "",
            displayName: "Buy now link",
            group: "content"
        }),
        openInNewTab: setAttr({
            type: "Boolean",
            defaultValue: true,
            displayName: "Open in new tab",
            group: "style"
        })

    },
    "stepper": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        })
    },
    "nextStep": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        event: setAttr({
            type: "Text",
            displayName: 'Action',
            group: 'style',
            defaultValue: "click",
            validations: {
                in: [
                    { value: 'click', displayName: 'Click' },
                    { value: 'dblclick', displayName: 'Double Click' },
                    { value: 'mouseenter', displayName: 'Hover' },
                    { value: 'submit', displayName: 'Submit' }
                ]
            }
        })
    },
    "prevStep": {
        id: setAttr({
            type: "Text",
            displayName: 'ID',
            group: 'content'
        }),
        event: setAttr({
            type: "Text",
            displayName: 'Action',
            group: 'style',
            defaultValue: "click",
            validations: {
                in: [
                    { value: 'click', displayName: 'Click' },
                    { value: 'dblclick', displayName: 'Double Click' },
                    { value: 'mouseenter', displayName: 'Hover' },
                    { value: 'submit', displayName: 'Submit' }
                ]
            }
        })
    },
    "eventContainer": {
        showEvent: setAttr({
            displayName: 'Show event name',
            type: 'Text',
            description: 'Event name to show container',
            group: 'style'
        }),
        hideEvent: setAttr({
            displayName: 'Hide event name',
            type: 'Text',
            description: 'Event name to hide container',
            group: 'style'
        }),
    }
}